import React, { useEffect, useRef, useState, useMemo, useCallback, memo } from 'react';
import { useDispatch } from 'react-redux'
import { Stage, Layer, Shape, Image, Rect, Line, Circle } from "react-konva";
import Konva from 'konva';
import { exportStageSVG } from 'react-konva-to-svg';
import { optimize } from 'svgo';
import {
  IconButton,
  Grid,
  TextField,
  Tooltip,
  Box,
  Typography,
  Button,
  makeStyles,
  Drawer,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Menu,
  MenuItem,
  Select,
  TableContainer,
  TableBody,
  TableCell,
  TableRow,
  TableHead,
  Table,
  Checkbox,
  FormControlLabel
} from '@material-ui/core';
import TreeItem from '@material-ui/lab/TreeItem';
import Draggable from 'react-draggable';
import TimelineIcon from '@material-ui/icons/Timeline';
import PhotoCamera from '@material-ui/icons/PhotoCamera';
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import GridOnIcon from '@material-ui/icons/GridOn';
import PanToolIcon from '@material-ui/icons/PanTool';
import GestureIcon from '@material-ui/icons/Gesture';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import HeightIcon from '@material-ui/icons/Height';
import UndoIcon from '@mui/icons-material/Undo';
import RedoIcon from '@mui/icons-material/Redo';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import PublishIcon from '@material-ui/icons/Publish';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import AddIcon from '@material-ui/icons/AddCircle';
import DeleteIcon from '@material-ui/icons/Delete';
import UpdateIcon from '@material-ui/icons/Update';
import InfoIcon from '@material-ui/icons/Info';
import ViewInArIcon from '@mui/icons-material/ViewInAr';
import SettingsIcon from '@material-ui/icons/Settings';
import GetAppIcon from '@material-ui/icons/GetApp';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import ColumnHandler from './ColumnTypes/columnHandler';
import Mask from './mask.component';
import CanvasGrid from './grid.component';
import PanoramaFishEyeIcon from '@mui/icons-material/PanoramaFishEye';
import RectangleIcon from '@mui/icons-material/Rectangle';
import LuminCard from '../components/Column/LuminCard';
import { useSelector } from 'react-redux';
import EdgeOrREST from '../EdgeOrREST';
import { API_OBJECTS } from '../API/model/calculation.model';
import * as d3 from 'd3';
import ColumnEditor from './column-editor.component';
import MaskEditor from './mask-editor.component';
import GridEditor from './grid-editor.component';
import CustomMask from './custom-mask.component';
import ThreeDView from './3D/ThreeDView';
import Notification from '../components/shared/notification.component';
import planActions from '../store/actions/planActions';
import luminaireActions from '../store/actions/luminaireActions';
import PhotometricInformation from '../photometricManager/photometric-information.component';
import { HexColorPicker } from 'react-colorful';
import { v4 as uuidv4 } from 'uuid';
import notificationActions from '../store/actions/notificationActions';
import { AddPhotoAlternate, Straighten } from '@material-ui/icons';
import Page from '../components/Page';
import ContourMapLayer from './contour-map-layer.component';
import AddMark from './addMark.component';
import Mark from './mark.component';
import PNGConvertIcon from './images/PNGConvert.png';
import SVGConvertIcon from './images/SVGConvert.png';
import ContourValues from '../components/Settings/Comp_Contour_Values';
import { use } from 'react';
import roadActions from '../store/actions/roadActions';
import ReportCapture from './report-capture.component';
import ReportCaptureEditor from './report-capture-editor.component';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import { handleReportCaptureClick as handleReportCaptureClickUtil } from '../report/reportCaptureUtils';

function transformAsImage(widthScale, heightScale, angle) {
  var rad = angle * Math.PI / 180;
  var cos = Math.cos(rad);
  var sin = Math.sin(rad);

  return d3.geoTransform({
    point: function (x, y) {
      var xRotated = x * cos - y * sin; var yRotated = x * sin + y * cos;
      this.stream.point((xRotated * widthScale), (yRotated * heightScale));

    }
  });
}

const useStyles = makeStyles((theme) => ({
  drawer: {
    position: 'relative',
    '& .MuiDrawer-paper': {
      top: '64px',
      height: `calc(100% - 64px)`,
      zIndex: 1000
    },
  },
}));

function useThrottle(callback, delay) {
  const lastCall = useRef(0);

  return useCallback((...args) => {
    const now = Date.now();
    if (now - lastCall.current >= delay) {
      lastCall.current = now;
      callback(...args);
    }
  }, [callback, delay]);
}

export default function PlanDashboard() {
  const state = useSelector(state => state);
  const classes = useStyles();
  const dispatch = useDispatch();

  const contourGridLayerRef = React.useRef();
  const gridTrRef = React.useRef();


  const imageRef = React.useRef();
  const imageLayerRef = React.useRef();
  const stageRef = React.useRef();
  const contourImageRef = React.useRef();
  const contourLayerRef = React.useRef();
  const contourShapeRef = React.useRef();
  const planRef = React.useRef();
  const linesLayerRef = React.useRef();
  const scaleInputRef = React.useRef(null);
  const layerRef = React.useRef();

  const [showContours, setShowContours] = React.useState(false);
  const [showMark, setShowMark] = React.useState(false);
  const [gridSelected, setGridSelected] = React.useState(false);

  const [lines, setLines] = React.useState([]);
  const [image, setImage] = React.useState(null);
  const [imagePixelHeight, setImagePixelHeight] = React.useState(0);
  const [imagePixelWidth, setImagePixelWidth] = React.useState(0);

  const [newGridXStart, setNewGridXStart] = React.useState(0);
  const [newGridYStart, setNewGridYStart] = React.useState(0);
  const [newGridHeight, setNewGridHeight] = React.useState(50);
  const [newGridWidth, setNewGridWidth] = React.useState(50);
  const [newGridShowResults, setNewGridShowResults] = React.useState(false);

  const [throttleSceneFunc, setThrottleSceneFunc] = React.useState(true);
  const [realWorldHeight, setRealWorldHeight] = React.useState(500);
  const [realWorldWidth, setRealWorldWidth] = React.useState(800);
  const [gridScaleX, setGridScaleX] = React.useState(1);
  const [gridScaleY, setGridScaleY] = React.useState(1);
  const [metresPerPixelX, setMetresPerPixelX] = React.useState(1);
  const [metresPerPixelY, setMetresPerPixelY] = React.useState(1);
  const [contourImage, setContourImage] = React.useState(null);
  const [columns, setColumns] = React.useState([]);
  const [maskMode, setMaskMode] = React.useState(false);
  const [masks, setMasks] = React.useState([]);
  const [stage, setStage] = React.useState({
    scale: 1,
    x: 0,
    y: 0,
  });

  const [polarInfo, setPolarInfo] = useState(null);
  const [areaResults, setAreaResults] = React.useState([]);
  const [areaGridResults, setAreaGridResults] = React.useState([]);
  const [contourGridResults, setContourGridResults] = React.useState([]);
  const [visualGrid, setVisualGrid] = React.useState({
    x: 0,
    y: 0,
    height: 100,
    width: 100
  })
  const [startCalc, setStartCalc] = React.useState(Date.now());
  const [grids, setGrids] = React.useState([{
    selected: false,
    name: "Grid #0",
    angle: 0,
    showResults: false,
    edgeStart: "False",
    id: 0,
    maskAll: "False",
    maskingLayer: "0",
    obsAngle: 0,
    obsHeight: 1.5,
    xSpacing: 1.5,
    ySpacing: 1.5,
    origin:
    {
      x: {
        start: 0,
        length: 25
      },
      y: {
        start: 0,
        length: 25
      },
      z: {
        start: 0,
        length: 0
      }
    },
    maxSpacing: 1.5,
    type: "Horizontal",
    verticalGridSide: "False"
  }]);
  const [isDrawing, setIsDrawing] = React.useState(false);
  const [drawings, setDrawings] = React.useState([]);
  const [currentDrawingId, setCurrentDrawingId] = React.useState(null);
  const [currentLine, setCurrentLine] = React.useState(null);
  const [previewPoint, setPreviewPoint] = useState(null);

  const [measureMode, setMeasureMode] = React.useState(false);
  const [measureStartPoint, setMeasureStartPoint] = React.useState(null);
  const [measureDistance, setMeasureDistance] = React.useState(0);
  const [measureLine, setMeasureLine] = React.useState([]);
  const [leftDrawerOpen, setLeftDrawerOpen] = React.useState(true);
  const [rightDrawerOpen, setRightDrawerOpen] = React.useState(true);
  const [uploadAreaOpen, setUploadAreaOpen] = React.useState(false);
  const [contourSettingsOpen, setContourSettingsOpen] = React.useState(false);
  const [markOpen, setMarkOpen] = React.useState(false);
  const [markDetails, setMarkDetails] = React.useState({});
  const [threeDView, set3dView] = React.useState(false);
  const [luminNameList, setLuminNameList] = React.useState([]);
  const [numberOfLuminaires, setNumberOfLuminaires] = React.useState(0);
  const [luminName, setLuminName] = React.useState("");
  const [addLuminOpen, setAddLuminOpen] = React.useState(false);
  const [luminInfoOpen, setLuminInfoOpen] = React.useState(false);
  const [luminSettingOpen, setLuminSettingOpen] = React.useState(false);
  const [infoLumin, setInfoLumin] = React.useState(0);
  const [cursorType, setCursorType] = React.useState('default');
  const [mousePosition, setMousePosition] = React.useState({ x: 0, y: 0 });
  const [mouseCoords, setMouseCoords] = React.useState({ x: 0, y: 0 });
  const [currentLuminId, setCurrentLuminId] = React.useState(0);
  const [settingId, setSettingId] = React.useState(0);
  const [colors, setColors] = React.useState([]);
  const [color, setColor] = React.useState('#212529');
  const [settingGridXStart, setSettingGridXStart] = React.useState(0);
  const [settingGridYStart, setSettingGridYStart] = React.useState(0);
  const [settingGridHeight, setSettingGridHeight] = React.useState(0);
  const [settingGridWidth, setSettingGridWidth] = React.useState(0);
  const [multipleSelect, setMultipleSelect] = React.useState(false);
  const [validDrawing, setValidDrawing] = React.useState(false);
  const [maskName, setMaskName] = React.useState(1);
  const [polyMaskIn, setPolyMaskIn] = React.useState(true);
  const [contourColors, setContourColors] = React.useState(state.ProjectConfig.contourColors);
  const [contourValues, setContourValues] = React.useState(state.ProjectConfig.contourValues);
  const [autoContourValues, setAutoContourValues] = React.useState(state.ProjectConfig.autoContourValues);

  const [scaleInput, setScaleInput] = React.useState(stage.scale);
  const [isEditingScale, setIsEditingScale] = React.useState(false);
  const [columnSearchTerm, setColumnSearchTerm] = React.useState("");
  const [gridSearchTerm, setGridSearchTerm] = React.useState("");
  const [maskSearchTerm, setMaskSearchTerm] = React.useState("");
  const [drawingFileSearchTerm, setDrawingFileSearchTerm] = React.useState("");
  const [sortState, setSortState] = React.useState(null);
  const [isInSnapRange, setIsInSnapRange] = React.useState(false);

  const [contextMenu, setContextMenu] = React.useState(false);
  const [contextMenuMaskIndex, setContextMenuMaskIndex] = React.useState(null);
  const [contextMenuPointIndex, setContextMenuPointIndex] = React.useState(null);
  const [contextMenuPosition, setContextMenuPosition] = React.useState({ top: 0, left: 0 });

  const [savedConfigs, setSavedConfigs] = React.useState([]);
  const [configName, setConfigName] = React.useState('');
  const [currValueId, setCurrValueId] = React.useState(0);
  const [defaultColumnSettings, setDefaultColumnSettings] = React.useState([]);
  const [defaultColumnSettingValues, setDefaultColumnSettingValues] = React.useState({
    dimFactor: 1,
    columnGrid: 0,
    height: 6,
    maintenanceFactor: 1,
    outreach: 1,
    cant: 0,
    tilt: 0,
  });
  const [reportCaptureAreas, setReportCaptureAreas] = React.useState([]);

  const saveConfig = (e, id) => {
    console.log("called saveConfig", columns)
    setSavingConfig(true);
    const config = {
      grids: grids,
      columns: columns,
      masks: masks,
      realWorldHeight: realWorldHeight,
      realWorldWidth: realWorldWidth,
      imagePixelHeight: imagePixelHeight,
      imagePixelWidth: imagePixelWidth,
      // image: image ? image.src : null,
      contourImage: contourImage ? contourImage.src : null,
      contourColors: contourColors,
      contourValues: contourValues,
      autoContourValues: autoContourValues,
      visualGrid: visualGrid,
      stage: stage,
      lines: lines,
      areaResults: areaResults,
      areaGridResults: areaGridResults,
      contourGridResults: contourGridResults,
      showContours: showContours,
      gridSelected: gridSelected,
      gridScaleX: gridScaleX,
      gridScaleY: gridScaleY,
      metresPerPixelX: metresPerPixelX,
      metresPerPixelY: metresPerPixelY,
      maskMode: maskMode,
      isDrawing: isDrawing,
      currentLine: currentLine,
      luminNameList: luminNameList,
      numberOfLuminaires: numberOfLuminaires,
      luminName: luminName,
      infoLumin: infoLumin,
      currentLuminId: currentLuminId,
      settingId: settingId,
      colors: colors,
      color: color,
      settingGridXStart: settingGridXStart,
      settingGridYStart: settingGridYStart,
      settingGridHeight: settingGridHeight,
      settingGridWidth: settingGridWidth,
      contextMenu: contextMenu,
      contextMenuMaskIndex: contextMenuMaskIndex,
      contextMenuPointIndex: contextMenuPointIndex,
      contextMenuPosition: contextMenuPosition,
      refs: {
        contourGridLayerRef: contourGridLayerRef.current ? contourGridLayerRef.current.attrs : null,
        gridTrRef: gridTrRef.current ? gridTrRef.current.attrs : null,
        imageRef: imageRef.current ? imageRef.current.attrs : null,
        imageLayerRef: imageLayerRef.current ? imageLayerRef.current.attrs : null,
        // stageRef: stageRef.current ? stageRef.current.attrs  : null,
        // contourImageRef: contourImageRef.current ? contourImageRef.current.attrs : null,
        // contourLayerRef: contourLayerRef.current ? contourLayerRef.current.attrs : null,
        contourShapeRef: contourShapeRef.current ? contourShapeRef.current.attrs : null,
        // planRef: planRef.current ? planRef.current: null,
        linesLayerRef: linesLayerRef.current ? linesLayerRef.current.attrs : null,
      },
      defaultColumnSettings: defaultColumnSettings,
      drawingId: currentDrawingId,
      selectedLuminaires: state.Plan?.selectedLuminaires,
      selectedLuminaireNames: state.Plan?.selectedLuminaireNames,
      selectedLuminaireColors: state.Plan?.selectedLuminaireColors,
      reportCaptureAreas: reportCaptureAreas,
    };
    console.log("config save", config);

    if (id == 0) {
      const postobject = {
        description: configName == '' ? 'Configuration #' + (savedConfigs.length + 1) : configName,
        config: JSON.stringify(config)
      }
      EdgeOrREST(null, "SET_PLAN_SESSION", onSaveConfig, postobject);
    } else {
      const postobject = {
        id: id,
        description: configName == '' ? 'Configuration #' + (savedConfigs.length + 1) : configName,
        config: JSON.stringify(config)
      }
      EdgeOrREST(null, "UPDATE_PLAN_SESSION", onSaveConfig, postobject);
    }

    setConfigName('');
  };

  const onSaveConfig = (response) => {
    console.log("onSaveConfig", response);
    if (response && response.status == "200") {
      setSnack({
        open: true,
        message: "Configuration saved successfully.",
        severity: 'success'
      });
      getAllPlanSessions();
      // } else {
      //   setSnack({
      //     open: true,
      //     message: "Configuration saved failed. Please try again.",
      //     severity: 'error'
      //   });
    }
    setSavingConfig(false);
  };

  const handleLoadConfig = (e, id) => {
    console.log("called handleLoadConfig", id);
    EdgeOrREST(null, "GET_PLAN_SESSION_BY_ID", loadConfig, { headers: { 'id': id } });
  };

  const loadConfig = (response) => {
    if (!response || !response.data) {
      setSnack({
        open: true,
        message: "Load failed: Configuration not found",
        severity: 'warning'
      });
      return;
    }

    const tempConfig = JSON.parse(response.data.config);

    const proceed = () => {
      setRealWorldHeight(tempConfig.realWorldHeight);
      setRealWorldWidth(tempConfig.realWorldWidth);
      setImagePixelHeight(tempConfig.imagePixelHeight);
      setImagePixelWidth(tempConfig.imagePixelWidth);
      applyConfig(tempConfig);
    };

    if (tempConfig.image && tempConfig.image !== 'null') {
      const img = new window.Image();
      img.src = tempConfig.image;
      img.crossOrigin = "Anonymous";

      img.onload = function () {
        setImage(img);
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            proceed();
          });
        });
      };

      img.onerror = function () {
        setSnack({
          open: true,
          message: "Load failed: Unable to load image",
          severity: 'warning'
        });
      };
    } else {
      setGridScaleY(tempConfig.gridScaleY);
      setGridScaleX(tempConfig.gridScaleX);
      proceed();
    }
  };

  const applyConfig = (tempConfig) => {
    console.log("applyConfig");
    setGridScaleY(tempConfig.gridScaleY);
    setGridScaleX(tempConfig.gridScaleX);
    setGrids(tempConfig.grids);
    setVisualGrid(tempConfig.visualGrid);

    if (tempConfig.refs) {
      if (tempConfig.refs.contourGridLayerRef?.current) contourGridLayerRef.current.attrs = tempConfig.refs.contourGridLayerRef;
      if (tempConfig.refs.gridTrRef?.current) gridTrRef.current.attrs = tempConfig.refs.gridTrRef;
      if (tempConfig.refs.imageRef?.current) imageRef.current.attrs = tempConfig.refs.imageRef;
      if (tempConfig.refs.imageLayerRef?.current) imageLayerRef.current.attrs = tempConfig.refs.imageLayerRef;
      if (tempConfig.refs.contourShapeRef?.current) contourShapeRef.current.attrs = tempConfig.refs.contourShapeRef;
      if (tempConfig.refs.linesLayerRef?.current) linesLayerRef.current.attrs = tempConfig.refs.linesLayerRef;
    }

    let highestNumber = 0;
    const masks = tempConfig.masks || [];
    masks.forEach((mask) => {
      const match = mask.name.match(/^Mask #(\d+)$/);
      if (match) {
        const number = parseInt(match[1], 10);
        if (number > highestNumber) {
          highestNumber = number;
        }
      }
    });

    setMaskName(highestNumber + 1);
    setStage(tempConfig.stage);
    setLines(tempConfig.lines);
    setLuminNameList(tempConfig.luminNameList);
    setNumberOfLuminaires(tempConfig.numberOfLuminaires);
    setLuminName(tempConfig.luminName);
    setCurrentLuminId(tempConfig.currentLuminId);
    setSettingId(tempConfig.settingId);
    setColors(tempConfig.colors);
    setColor(tempConfig.color);
    setSettingGridXStart(tempConfig.settingGridXStart);
    setSettingGridYStart(tempConfig.settingGridYStart);
    setSettingGridHeight(tempConfig.settingGridHeight);
    setSettingGridWidth(tempConfig.settingGridWidth);
    setContextMenu(tempConfig.contextMenu);
    setContextMenuMaskIndex(tempConfig.contextMenuMaskIndex);
    setContextMenuPointIndex(tempConfig.contextMenuPointIndex);
    setContextMenuPosition(tempConfig.contextMenuPosition);
    setDefaultColumnSettings(tempConfig.defaultColumnSettings);
    setShowContours(tempConfig.showContours);
    setContourColors(tempConfig.contourColors);
    setContourValues(tempConfig.contourValues);
    setAutoContourValues(tempConfig.autoContourValues);
    setReportCaptureAreas(tempConfig.reportCaptureAreas || []);
    setColumns(tempConfig.columns);
    setMasks(tempConfig.masks);

    if (tempConfig.drawingId != null && tempConfig.drawingId !== 0) {
      EdgeOrREST(null, 'LOAD_DRAWING', (response) => onLoadDrawing(false, response), tempConfig.drawingId);
      setCurrentDrawingId(tempConfig.drawingId);
      dispatch(notificationActions.UpdateImageLoad({ imageLoad: true }));
    } else {
      onLoadDrawing(false, null);
    }

    let tempSelectedLuminaires = tempConfig.selectedLuminaires || [];
    let tempSelectedLuminaireNames = tempConfig.selectedLuminaireNames || [];
    let tempSelectedLuminaireColors = tempConfig.selectedLuminaireColors || [];

    dispatch(roadActions.AddToCurrentState({
      contourColors: tempConfig.contourColors,
      contourValues: tempConfig.contourValues,
      autoContourValues: tempConfig.autoContourValues,
      showContours: tempConfig.showContours
    }));

    dispatch(planActions.UpdatePlanLuminaires({
      selectedLuminaires: tempSelectedLuminaires,
      selectedLuminaireNames: tempSelectedLuminaireNames,
      selectedLuminaireColors: tempSelectedLuminaireColors
    }));

    dispatch(luminaireActions.UpdateLuminaireList({
      ...state.LuminaireCfg,
      selectedLuminaireIds: tempSelectedLuminaires,
    }));

    setStartCalc(Date.now());
  };

  const deleteConfig = (id) => {
    EdgeOrREST(null, "DELETE_PLAN_SESSION", onDeleteConfig, { id: id });
    setSavedConfigs(savedConfigs.filter(config => config.id !== id));
  };

  const onDeleteConfig = (response) => {
    if (response && response.status == "200") {
      setSnack({
        open: true,
        message: "Configuration deleted successfully.",
        severity: 'success'
      });
    } else {
      setSnack({
        open: true,
        message: "Configuration delete failed. Please try again.",
        severity: 'error'
      });
    }
  };

  const getAllPlanSessions = () => {
    console.log("called getAllPlanSessions");
    EdgeOrREST(null, "GET_ALL_PLAN_SESSION", onGetAllPlanSessionsDescription, null);
  }

  React.useEffect(() => {
    getAllPlanSessions();
  }, []);

  const onGetAllPlanSessionsDescription = (response) => {
    console.log("onGetAllPlanSessionsDescription", response);
    if (response && response.data) {
      setSavedConfigs(response.data);
    } else if (response && response.status == "204") {
      setSavedConfigs([]);
    } else {
      setSnack({
        open: true,
        message: "Get configurations failed.",
        severity: 'warning'
      });
    }
  };

  const handleWheel = (e) => {
    e.evt.preventDefault();
    const scaleBy = 1.05;
    const stage = e.target.getStage();
    const oldScale = stage.scaleX();
    const newScale = Math.min(Math.max(e.evt.deltaY < 0 ? oldScale * scaleBy : oldScale / scaleBy, 0.01), 100); // Prevent scale from going to 0 or over 100

    const center = {
      x: stage.width() / 2,
      y: stage.height() / 2,
    };

    const relatedTo = {
      x: (center.x - stage.x()) / oldScale,
      y: (center.y - stage.y()) / oldScale,
    };

    setStage({
      scale: newScale,
      x: center.x - relatedTo.x * newScale,
      y: center.y - relatedTo.y * newScale
    });
  };

  const onSetHeight = (e) => {
    console.log("called onSetHeight")
    setRealWorldHeight(e.target.value);
    if (image) {
      setGridScaleY(image.naturalHeight / e.target.value);
      setGridScaleX(image.naturalWidth / realWorldWidth);
      console.log("img.naturalHeight, img.naturalWidth, realWorldHeight, realWorldWidth", image.naturalHeight, image.naturalWidth, realWorldHeight, realWorldWidth);
    }

  }

  const onSetWidth = (e) => {
    console.log("called onSetWidth")
    setRealWorldWidth(e.target.value);

    if (image) {
      setGridScaleY(image.naturalHeight / realWorldHeight);
      setGridScaleX(image.naturalWidth / e.target.value);
      console.log("img.naturalHeight, img.naturalWidth, realWorldHeight, realWorldWidth", image.naturalHeight, image.naturalWidth, realWorldHeight, realWorldWidth);

    }
  }

  const onSetImage = (e) => {
    dispatch(notificationActions.UpdateImageLoad({ imageLoad: true }));
    console.log("called onSetImage")
    const img = new window.Image();
    img.src = URL.createObjectURL(e.target.files[0]);
    img.crossOrigin = "Anonymous";

    img.onload = function () {
      console.log("img.naturalHeight, img.naturalWidth, realWorldHeight, realWorldWidth", img.naturalHeight, img.naturalWidth, realWorldHeight, realWorldWidth);
      setGridScaleY(img.naturalHeight / realWorldHeight);
      setGridScaleX(img.naturalWidth / realWorldWidth);
      setImagePixelHeight(img.height);
      setImagePixelWidth(img.width);
      setImage(img);
      setSnack({
        open: true,
        message: "Drawing loaded successfully.",
        severity: 'success',
        action: 'upload completed'
      });
      dispatch(notificationActions.UpdateImageLoad({ imageLoad: false }));


      var tempGridStr = JSON.stringify(grids);
      var tempGrid = JSON.parse(tempGridStr);
      tempGrid[0].origin.x.length = realWorldWidth;
      tempGrid[0].origin.y.length = realWorldHeight;
      setGrids(tempGrid);
      //grid is being set to the same size as the image 
      setVisualGrid({
        x: grids[0].origin.x.start * (img.naturalWidth / realWorldWidth),
        y: grids[0].origin.y.start * (img.naturalHeight / realWorldHeight),
        width: realWorldWidth * (img.naturalWidth / realWorldWidth),
        height: realWorldHeight * (img.naturalHeight / realWorldHeight)
      });
    }
  }

  const onSetSvgImage = (svgImage, scaleFactor, moveCamera = true) => {
    const svgToUse = svgImage || generateBlankSvg(150, 150);

    const optimizedResult = optimize(svgToUse, {
      multipass: true,
      plugins: [
        {
          name: 'preset-default',
          params: {
            overrides: {
              // precision overrides (you already have)
              cleanupNumericValues: { floatPrecision: 1 },
              convertPathData: { floatPrecision: 1, transformPrecision: 1 },
              convertTransform: { floatPrecision: 1, transformPrecision: 1 },
              mergePaths: { floatPrecision: 1 },

              cleanupNumericValues: { floatPrecision: 1 },
              convertPathData: { floatPrecision: 1, transformPrecision: 1 },
              convertTransform: { floatPrecision: 1, transformPrecision: 1 },
              mergePaths: { floatPrecision: 1 },

              // structural / size‑saving plugins
              removeXMLProcInst: true,
              removeDoctype: true,
              removeComments: true,
              removeMetadata: true,
              removeTitle: true,
              removeDesc: true,
              removeUselessDefs: true,
              cleanupAttrs: true,
              cleanupIDs: true,
              removeUnknownsAndDefaults: true,
              collapseGroups: true,
              removeEmptyContainers: true,
              removeEmptyText: true,
              removeEmptyAttrs: true,
              convertColors: true,
              sortDefsChildren: true,
              sortAttrs: true,
              removeDimensions: true,
              removeXMLProcInst: true,
              removeDoctype: true,
              removeComments: true,
              removeMetadata: true,
              removeTitle: true,
              removeDesc: true,
              removeUselessDefs: true,
              cleanupAttrs: true,
              cleanupIDs: true,
              removeUnknownsAndDefaults: true,
              collapseGroups: true,
              removeEmptyContainers: true,
              removeEmptyText: true,
              removeEmptyAttrs: true,
              convertColors: true,
              sortDefsChildren: true,
              sortAttrs: true,
              removeDimensions: true,
            },
          },
        },
      ],
    });
    const optimizedSvg = optimizedResult.data;
    const parser = new DOMParser();
    const svgDoc = parser.parseFromString(optimizedSvg, "image/svg+xml");
    const svgElement = svgDoc.documentElement;  // This should be the <svg> element

    // Extract the width and height from the SVG's attributes
    let pixelHeight = parseFloat(svgElement.getAttribute("height"));
    let pixelWidth = parseFloat(svgElement.getAttribute("width"));
    // Compute real-world dimensions from the pixel dimensions and scale factor
    const realHeight = pixelHeight * scaleFactor;  // Height in meters
    const realWidth = pixelWidth * scaleFactor;    // Width in meters

    setRealWorldHeight(realHeight);
    setRealWorldWidth(realWidth);

    // Create a new Image object for the SVG
    const img = new window.Image();
    img.src = 'data:image/svg+xml;base64,' + btoa(optimizedSvg); // Encode the SVG data to base64 and set as src
    img.crossOrigin = "Anonymous";

    img.onload = function () {
      // Image dimensions can be used if needed but we already have pixelHeight/pixelWidth from the API
      const svgPixelHeight = img.naturalHeight;
      const svgPixelWidth = img.naturalWidth;

      // Set grid scaling based on real-world dimensions
      setGridScaleY(svgPixelHeight / realHeight);
      setGridScaleX(svgPixelWidth / realWidth);

      // Set the image's pixel height and width
      setImagePixelHeight(svgPixelHeight);
      setImagePixelWidth(svgPixelWidth);
      setImage(img);  // Set the image object for further use if necessary

      // Handle grid scaling and set the grid dimensions
      var tempGridStr = JSON.stringify(grids);
      // Set the grid lengths to match the real-world dimensions
      setGrids(prevGrids => {
        const updatedGrids = [...prevGrids];
        updatedGrids[0] = {
          ...updatedGrids[0],
          origin: {
            ...updatedGrids[0].origin,
            x: {
              ...updatedGrids[0].origin.x,
              length: realWidth,
            },
            y: {
              ...updatedGrids[0].origin.y,
              length: realHeight,
            },
          },
        };
        return updatedGrids;
      });


      // Set visual grid based on scaling factors
      setVisualGrid({
        x: grids[0].origin.x.start * (svgPixelWidth / realWidth),
        y: grids[0].origin.y.start * (svgPixelHeight / realHeight),
        width: realWidth * (svgPixelWidth / realWidth),
        height: realHeight * (svgPixelHeight / realHeight)
      });

      if (moveCamera) {
        const stage = stageRef.current;
        const scale = stage.scaleX();
        const stageWidth = stage.width();
        const stageHeight = stage.height();

        const imageCenterX = svgPixelWidth / 2;
        const imageCenterY = svgPixelHeight / 2;

        const newX = -imageCenterX * scale + stageWidth / 2;
        const newY = -imageCenterY * scale + stageHeight / 2;

        stage.position({ x: newX, y: newY });
        stage.batchDraw();
      }

    }
  }

  const onSetPNGImage = (pngImage, scaleFactor) => {
    const img = new window.Image();
    img.src = 'data:image/png;base64,' + pngImage;
    img.crossOrigin = "Anonymous";
    img.onload = function () {
      const pixelHeight = img.height;
      const pixelWidth = img.width;
      const realHeight = pixelHeight * scaleFactor;
      const realWidth = pixelWidth * scaleFactor;

      setRealWorldHeight(realHeight);
      setRealWorldWidth(realWidth);

      setGridScaleY(pixelHeight / realHeight);
      setGridScaleX(pixelWidth / realWidth);
      setImagePixelHeight(pixelHeight);
      setImagePixelWidth(pixelWidth);
      setImage(img);

      var tempGridStr = JSON.stringify(grids);
      var tempGrid = JSON.parse(tempGridStr);
      tempGrid[0].origin.x.length = realWidth;
      tempGrid[0].origin.y.length = realHeight;
      setGrids(tempGrid);

      setVisualGrid({
        x: grids[0].origin.x.start * (pixelWidth / realWidth),
        y: grids[0].origin.y.start * (pixelHeight / realHeight),
        width: realWidth * (pixelWidth / realWidth),
        height: realHeight * (pixelHeight / realHeight)
      });
    }
  }

  const exportToDWG = async (e) => {
    const file = e.target.files[0];
    const svg = await exportStageSVG(stageRef.current, false);
    if (file) {
      EdgeOrREST(null, 'EXPORT_TO_DWG', onExportToDWG, { file, svg });
    }
  }

  const onExportToDWG = (response) => {
    const blob = new Blob([response.data], { type: 'application/octet-stream' });

    // Attempt to extract the filename from the Content-Disposition header
    let fileName = 'download.dwg'; // Default filename
    const contentDisposition = response.headers['content-disposition'];

    if (contentDisposition && contentDisposition.indexOf('attachment') !== -1) {
      const fileNameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
      if (fileNameMatch && fileNameMatch.length > 1) {
        fileName = fileNameMatch[1];
      }
    }

    // Create a link element, set the href to the blob URL, and trigger a click
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName); // Set the filename for the download
    document.body.appendChild(link);
    link.click();

    // Clean up and revoke the object URL after the download
    link.parentNode.removeChild(link);
    window.URL.revokeObjectURL(url);
  }

  const UploadDWGToPNG = (e) => {
    const file = e.target.files[0];
    dispatch(notificationActions.UpdateImageLoad({ imageLoad: true }));
    if (file) {
      EdgeOrREST(null, 'CONVERT_TO_PNG', onConvertToPNG, file);
    }
  }
  const onConvertToPNG = (response) => {
    if (response) {
      const { img, pixelsToMetersX, pixelsToMetersY } = response;
      onSetPNGImage(img, 1);
      setSnack({
        open: true,
        message: "Drawing converted to png successfully.",
        severity: 'success',
        action: 'upload completed'
      });
      dispatch(notificationActions.UpdateImageLoad({ imageLoad: false }));
    }
  };

  const handleUpdateClick = async () => {
    try {
      const [fileHandle] = await window.showOpenFilePicker({
        types: [
          {
            description: 'Drawing Files',
            accept: {
              'application/octet-stream': ['.dwg', '.dxf'],
            },
          },
        ],
        excludeAcceptAllOption: true,
        multiple: false,
      });

      const file = await fileHandle.getFile();
      onUpload(file);
    } catch (err) {
      console.error(err);
    }
  };




  const onUpload = async (e) => {
    const file = e.target.files[0];
    dispatch(notificationActions.UpdateImageLoad({ imageLoad: true }));
    if (file) {
      EdgeOrREST(null, 'CONVERT_TO_SVG', onConvertToSVG, file);
    }
  };

  const onConvertToSVG = (response) => {
    if (response) {
      const { svg, pixelsToMetersX, pixelsToMetersY, drawingFiles } = response;
      onSetSvgImage(svg, 1);
      if (drawingFiles != null || drawingFiles != undefined) setDrawings(drawingFiles);
      setSnack({
        open: true,
        message: "Drawing converted to svg successfully.",
        severity: 'success',
        action: 'upload completed'
      });
      dispatch(notificationActions.UpdateImageLoad({ imageLoad: false }));
    }
  };



  const doAreaCalc = (e) => {
    console.log("doAreaCalc", columns.length > 0, image != null, state.LuminaireCfg.selectedLuminaireIds != null, state.LuminaireCfg.selectedLuminaireIds.length > 0);
    if (columns.length > 0 && image != null && state.LuminaireCfg.selectedLuminaireIds != null && state.LuminaireCfg.selectedLuminaireIds.length > 0) {
      console.log("contourGridLayerRef", contourGridLayerRef);
      var scaleX = contourGridLayerRef.current.attrs.width / realWorldWidth;
      var scaleY = contourGridLayerRef.current.attrs.height / realWorldHeight;

      var strGrids = JSON.stringify(grids);
      var tempGrids = JSON.parse(strGrids);
      for (var i = 0; i < tempGrids.length; i++) {
        var grid = tempGrids[i];
        var xSpacing = grid.xSpacing;
        var ySpacing = grid.ySpacing;
        var xPoints = Math.ceil(grid.origin.x.length / xSpacing);
        var yPoints = Math.ceil(grid.origin.y.length / ySpacing);

        while (xPoints * yPoints > 60000) {
          if (xPoints * yPoints > 60000) {
            xSpacing += 0.5;
            ySpacing += 0.5;
          }
          xPoints = Math.ceil(grid.origin.x.length / xSpacing);
          yPoints = Math.ceil(grid.origin.y.length / ySpacing);
        }

        grid.xSpacing = xSpacing;
        grid.ySpacing = ySpacing;
        grid.maxSpacing = Math.max(xSpacing, ySpacing);
      }
      setGrids(tempGrids);
      var calculationObject = API_OBJECTS.getCalculationObject(state, null, null);
      console.log("calculationObject", calculationObject);
      calculationObject["areaGrids"] = tempGrids;
      var lampPosts = [];
      for (i = 0; i < columns.length; i++) {
        var jsontemp = JSON.stringify(columns[i].values);
        var tempValues = JSON.parse(jsontemp);
        // console.log("columns[i + 1].values.point.x", columns[i].values.point.x);
        // console.log("columns[i + 1].values.point.y", columns[i].values.point.y);

        if (columns[i].isMast === true) {
          const lanterns = columns[i]?.values?.lanterns;
          tempValues.lanterns = Array.isArray(lanterns) ? [...lanterns] : [];
        } else {
          tempValues.lanterns = null;
        }

        let angle = parseFloat(columns[i].values.positionAngle) - 90;
        if (angle < 0) angle += 360;
        tempValues.positionAngle = angle;

        console.log("tempValues", tempValues, columns);

        tempValues.luminaireId = columns[i].values.luminaireId;
        tempValues.point.x = columns[i].values.point.x / scaleX;
        tempValues.point.y = columns[i].values.point.y / scaleY;
        lampPosts.push(tempValues);
      }
      calculationObject["areaColumns"] = lampPosts;
      //masks only contain polygon square and circles 
      var maskConversions = [];
      for (i = 0; i < masks.length; i++) {
        var currMask = {};
        currMask.points = [];
        currMask.mode = masks[i].maskIn;
        currMask.layer = 0;
        currMask.rotation = masks[i].rotation;
        for (var j = 0; j < masks[i].points.length; j++) {
          // console.log("mask i points", masks[i].points);
          // console.log("j", j);
          // console.log("i", i);
          // console.log("masks[i].points[j].x", masks[i].points[j].x);
          currMask.points.push({ x: masks[i].points[j].x, y: masks[i].points[j].y });
        }
        if (masks[i].type == "circle") {
          currMask.type = "circle";
          currMask.radius = masks[i].radius / scaleX;
          console.log(scaleX, scaleY)
          currMask.scaleX = masks[i].scaleX;
          currMask.scaleY = masks[i].scaleY;
        } else {
          currMask.type = "polygon";
        }
        maskConversions.push(currMask);
      }
      calculationObject["masks"] = maskConversions;
      console.log("onGetAreacalculationObject", calculationObject);
      calculationObject["luminaireIds"] = state.Plan.selectedLuminaires;

      if (grids.length > 1) {
        calculationObject.roadGrids[0].calcGridClassValue = grids[1].gridClass;
        calculationObject.roadGrids[0].standard = grids[1].gridStandard;
        calculationObject.roadGrids[0].calcGridFile = grids[1].gridStandard;
      }

      console.log("calcObj", calculationObject)

      EdgeOrREST(null, "GET_AREA", onGetAreaCalc, calculationObject);
    } else {
      console.log("columns.length", columns.length, "image != null", image != null, "state.LuminaireCfg.selectedLuminaireIds != null", state.LuminaireCfg.selectedLuminaireIds != null, "state.LuminaireCfg.selectedLuminaireIds.length > 0", state.LuminaireCfg.selectedLuminaireIds.length > 0);
      setContourGridResults([]);
      setAreaResults([]);
      setAreaGridResults([]);
    }
  }

  useEffect(() => {
    doAreaCalc();
  }, [startCalc]);

  const onGetAreaCalc = ((response) => {
    console.log("onGetAreaCalc", response);
    if (response && response.data) {

      for (var i = 0; i < response.data.length; i++) {

        var item = response.data[i];
        if (item.calcResults?.outdoorResults[0]?.gridId == 0) {
          setContourGridResults(item.calcResults?.outdoorResults[0].contourResults);
        }
        break;
      }
      setAreaResults(response.data);
    }

  });

  useEffect(() => {
    EdgeOrREST(null, "LOAD_DRAWINGS", onLoadDrawings, null);
  }, []);

  const onLoadDrawings = (response) => {
    if (response) {
      setDrawings(response.drawingFiles);
    }
  }

  useEffect(() => {
    setThrottleSceneFunc(false);
  }, [contourGridResults]);


  const updateGrid = (e, i, isTransform, newWidth, newHeight, newRotation) => {
    var tempGrids = JSON.parse(JSON.stringify(grids));
    var tempGrid = JSON.parse(JSON.stringify(grids[i]));

    if (isTransform) {
      tempGrid.origin.x.start = parseFloat(e.target.attrs.x.toFixed(2));
      tempGrid.origin.y.start = parseFloat(e.target.attrs.y.toFixed(2));
      tempGrid.origin.x.length = parseFloat(newWidth.toFixed(2));
      tempGrid.origin.y.length = parseFloat(newHeight.toFixed(2));
      tempGrid.angle = parseFloat(newRotation.toFixed(2));
    } else {
      tempGrid.origin.x.start = parseFloat(e.currentTarget.attrs.x.toFixed(2));
      tempGrid.origin.y.start = parseFloat(e.currentTarget.attrs.y.toFixed(2));
    }
    tempGrids[i] = tempGrid;
    setGrids(tempGrids);
    setStartCalc(Date.now());
  }

  const updateGridOnSave = (i, newName, newColor, gridStandard, gridClass, xSpacing, ySpacing, nameVisibility, edgeStart, showValues) => {
    if (!grids[i]) return;

    let tempGrids = JSON.parse(JSON.stringify(grids));
    tempGrids[i].name = newName;
    tempGrids[i].color = newColor;
    tempGrids[i].visible = nameVisibility;
    tempGrids[i].edgeStart = edgeStart;

    dispatch(roadActions.AddToCurrentState({ showValues: showValues }));

    if (xSpacing != tempGrids[i].xSpacing || ySpacing != tempGrids[i].ySpacing) {
      tempGrids[i].xSpacing = xSpacing;
      tempGrids[i].ySpacing = ySpacing;
    }

    if (gridStandard != tempGrids[i].gridStandard || gridClass != tempGrids[i].gridClass) {
      tempGrids[i].gridStandard = gridStandard;
      tempGrids[i].gridClass = gridClass
    }

    setGrids(tempGrids);
    setStartCalc(Date.now());
  };

  const updateGridResults = (i, checked) => {
    if (!grids[i]) return;

    let tempGrids = JSON.parse(JSON.stringify(grids));
    tempGrids[i].showResults = checked;
    tempGrids[i].locked = true;
    tempGrids[i].selected = false;

    setGrids(tempGrids);
  };


  const deleteGrid = (id) => {
    setGrids(grids.filter((item) => item.id !== id));
    if (grids.length > 1) {
      setStartCalc(Date.now());
    }
  };


  const selectGrid = (id) => {
    let tempGrids = [...grids];
    if (!multipleSelect) {
      const gridIndex = tempGrids.findIndex(grid => grid.id === id);
      if (gridIndex !== -1) {
        if (tempGrids[gridIndex].selected === false) {
          tempGrids = tempGrids.map((grid) => ({
            ...grid,
            selected: grid.id === id ? !grid.selected : false,
          }));
        } else {
          const selectedCount = tempGrids.filter(grid => grid.selected).length;
          if (selectedCount > 1) {
            tempGrids[gridIndex].selected = true;
            tempGrids = tempGrids.map((grid) => ({
              ...grid,
              selected: grid.id === id ? true : false,
            }));
          } else {
            tempGrids[gridIndex].selected = !tempGrids[gridIndex].selected;
          }
        }
      }
    } else {
      const gridIndex = tempGrids.findIndex(grid => grid.id === id);
      if (gridIndex !== -1) {
        tempGrids[gridIndex].selected = !tempGrids[gridIndex].selected;
      }
    }

    const updatedGrid = tempGrids.find(grid => grid.id === id);
    if (updatedGrid) updatedGrid.locked = false;

    setGrids(tempGrids);
  };

  const deleteColumn = (id) => {
    setColumns(columns.filter((column) => column.id !== id));
    setStartCalc(Date.now());
  };


  const selectColumn = (id) => {
    let tempColumns = [...columns];
    if (!multipleSelect) {
      const columnIndex = tempColumns.findIndex(columns => columns.id === id);
      if (columnIndex !== -1) {
        if (tempColumns[columnIndex].selected === false) {
          tempColumns = tempColumns.map((column) => ({
            ...column,
            selected: column.id === id ? !column.selected : false,
          }));
        } else {
          const selectedCount = tempColumns.filter(column => column.selected).length;
          if (selectedCount > 1) {
            tempColumns[columnIndex].selected = true;
            tempColumns = tempColumns.map((column) => ({
              ...column,
              selected: column.id === id ? true : false,
            }));
          } else {
            tempColumns[columnIndex].selected = !tempColumns[columnIndex].selected;
          }
        }
      }
    } else {
      const columnIndex = tempColumns.findIndex(column => column.id === id);
      if (columnIndex !== -1) {
        tempColumns[columnIndex].selected = !tempColumns[columnIndex].selected;
      }
    }

    setColumns(tempColumns);
  };


  const updateColumn = (e, i) => {
    console.log("updateColumn", e, i);
    var tempColumns = [...columns];
    tempColumns[i].values.point.x = e.currentTarget.attrs.x
    tempColumns[i].values.point.y = e.currentTarget.attrs.y

    console.log("mouse", mouseCoords.x, mouseCoords.y);
    setColumns(tempColumns);
    setStartCalc(Date.now());
  }

  const handleScaleChange = (event) => {
    setScaleInput(event.target.value);
  };

  useEffect(() => {
    if (isEditingScale && scaleInputRef.current) {
      scaleInputRef.current.select();
    }
  }, [isEditingScale]);

  const handleTextClick = () => {
    setIsEditingScale(true);
    setScaleInput(stage.scale.toFixed(2));
  };

  const handleScaleBlur = () => {
    let newScale = parseFloat(scaleInput);

    const MIN_SCALE = 0.01;
    const MAX_SCALE = 100;

    if (newScale < MIN_SCALE) {
      newScale = MIN_SCALE;
    } else if (newScale > MAX_SCALE) {
      newScale = MAX_SCALE;
    }

    if (!isNaN(newScale)) {
      if (stageRef.current) {
        const stageWidth = stageRef.current.width();
        const stageHeight = stageRef.current.height();

        const currentPosition = stageRef.current.position();
        const currentScale = stageRef.current.scaleX();

        const scaleFactor = newScale / currentScale;

        const newX = currentPosition.x * scaleFactor + (stageWidth / 2) * (1 - scaleFactor);
        const newY = currentPosition.y * scaleFactor + (stageHeight / 2) * (1 - scaleFactor);

        new Konva.Tween({
          node: stageRef.current,
          duration: 0.5,
          easing: Konva.Easings.EaseInOut,
          scaleX: newScale,
          scaleY: newScale,
          x: newX,
          y: newY,
          onFinish: () => {
            if (layerRef.current) {
              layerRef.current.batchDraw();
            }
          },
        }).play();
      }

      stage.scale = newScale;
    }

    if (stageRef.current) {
      const appliedScale = stageRef.current.scaleX();
      setScaleInput(appliedScale.toFixed(2));
    }

    setIsEditingScale(false);
  };

  const handleColumnSearchChange = (event) => {
    setColumnSearchTerm(event.target.value);
  };


  const handleGridSearchChange = (event) => {
    setGridSearchTerm(event.target.value.toLowerCase());
  };

  const handleMaskSearchChange = (event) => {
    setMaskSearchTerm(event.target.value.toLowerCase());
  };

  const handleDrawingFileSearchChange = (event) => {
    setDrawingFileSearchTerm(event.target.value.toLowerCase());
  };

  const filteredColumns = columns.filter((column) =>
    column.name.toLowerCase().includes(columnSearchTerm)
  );

  const filteredGrids = grids.filter((grid) =>
    grid.name.toLowerCase().includes(gridSearchTerm)
  );

  const filteredMasks = masks.filter((mask) =>
    mask.name.toLowerCase().includes(maskSearchTerm)
  );

  const filteredDrawingFiles = drawings.filter((drawing) =>
    drawing.name.toLowerCase().includes(drawingFileSearchTerm)
  );

  const handleSort = () => {
    const sortOrderCycle = [null, "nameAsc", "nameDesc", "dateAsc", "dateDesc"];
    const nextIndex = (sortOrderCycle.indexOf(sortState) + 1) % sortOrderCycle.length;
    setSortState(sortOrderCycle[nextIndex]);
  };

  const getSortLabel = () => {
    switch (sortState) {
      case "nameAsc": return "Name ▲";
      case "nameDesc": return "Name ▼";
      case "dateAsc": return "Date ▲";
      case "dateDesc": return "Date ▼";
      default: return "None";
    }
  };

  const sortedDrawingFiles = [...(filteredDrawingFiles || [])].sort((a, b) => {
    if (!sortState) return 0;
    let comparison = 0;

    if (sortState === "nameAsc" || sortState === "nameDesc") {
      comparison = a.name.localeCompare(b.name);
    } else if (sortState === "dateAsc" || sortState === "dateDesc") {
      comparison = new Date(a.createDate) - new Date(b.createDate);
    }

    return (sortState === "nameDesc" || sortState === "dateDesc") ? -comparison : comparison;
  });


  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleScaleBlur();
    }
  };

  const updateRotate = (newAngle, index) => {
    const normalizedAngle = ((newAngle % 360) + 360) % 360;
    const roundedAngle = parseFloat(normalizedAngle.toFixed(2));

    const tempColumns = [...columns];
    const col = { ...tempColumns[index] };

    col.values.positionAngle = roundedAngle;

    tempColumns[index] = col;
    setColumns(tempColumns);
    setStartCalc(Date.now());
  };

  const getTiltFromBeamLength = (beamLength, height = 6) => {
    const radians = Math.atan(height / beamLength);
    const tilt = 90 - (radians * (180 / Math.PI));
    return +tilt.toFixed(2);
  };



  const updateLanternRotation = (newAngle, newLength, index, lanternIndex) => {
    const tempColumns = [...columns];
    const col = tempColumns[index];
    const lanterns = [...col.values.lanterns];

    if (lanterns && lanterns[lanternIndex]) {
      const updatedLantern = {
        ...lanterns[lanternIndex],
        positionAngle: newAngle,
      };

      if (newLength != null && !isNaN(newLength)) {
        updatedLantern.beamAimingInfo.beamLength = newLength;
        updatedLantern.beamAimingInfo.tilt = getTiltFromBeamLength(newLength, col.values.height);
      }

      lanterns[lanternIndex] = updatedLantern;
    }

    tempColumns[index] = {
      ...col,
      values: {
        ...col.values,
        lanterns,
      },
    };

    console.log("tempColumns", tempColumns);

    setColumns(tempColumns);
    setStartCalc(Date.now());
  };

  const updateLanternBeamEndpoint = ({
    beamEndPoint,
    beamLength,
    positionAngle,
    lanternIndex,
    columnIndex,
  }) => {
    const updatedColumns = [...columns];
    const column = updatedColumns[columnIndex];
    const lanterns = [...column.values.lanterns];
    const lantern = { ...lanterns[lanternIndex] };

    lantern.beamAimingInfo = {
      ...lantern.beamAimingInfo,
      beamEndPoint: {
        x: parseFloat(beamEndPoint.x.toFixed(2)),
        y: parseFloat(beamEndPoint.y.toFixed(2)),
      },
      beamLength: parseFloat(beamLength),
      tilt: getTiltFromBeamLength(beamLength, column.values.height),
    };

    const normalizedAngle = ((positionAngle % 360) + 360) % 360;
    const roundedAngle = parseFloat(normalizedAngle.toFixed(2));

    lantern.positionAngle = roundedAngle;

    lanterns[lanternIndex] = lantern;

    updatedColumns[columnIndex] = {
      ...column,
      values: {
        ...column.values,
        lanterns,
      },
    };

    setColumns(updatedColumns);
  };

  const fetchPolarInfo = () => {
    console.log("fetchPolarInfo", state);
    EdgeOrREST(
      null,
      "GET_POLAR",
      handlePolar,
      API_OBJECTS.getCalculationObject(state, null, null)
    );
  };

  const handlePolar = (response) => {
    console.log("handlePolar", response);
    if (response?.data != null && response.status === 200) {
      const polarData = response.data;
      console.log("Polar data received:", polarData);
      setPolarInfo(polarData);
    }
  };

  const updateLanterns = (newLanterns, columnIndex) => {
    setColumns((prevColumns) => {
      return prevColumns.map((col, idx) =>
        idx === columnIndex
          ? {
            ...col,
            values: {
              ...col.values,
              lanterns: newLanterns,
            },
          }
          : col
      );
    });
  };


  useEffect(() => {
    console.log("GridValues reference changed:", contourGridResults);
  }, [contourGridResults]);

  useEffect(() => {
    console.log("grids reference changed:", grids);
  }, [grids]);

  const focusColumn = (id) => {
    if (!validDrawing) {
      setSnack({
        open: true,
        message: "Please load a drawing first.",
        severity: 'warning'
      });
      return;
    };

    const column = columns.find(col => col.id === id);

    if (!column.selected) selectColumn(id);

    if (column) {
      const stageWidth = stageRef.current.width();
      const stageHeight = stageRef.current.height();

      const currentScale = stageRef.current.scaleX();

      const newX = -column.values.point.x * currentScale + stageWidth / 2;
      const newY = -column.values.point.y * currentScale + stageHeight / 2;

      new Konva.Tween({
        node: stageRef.current,
        duration: 1.5,
        easing: Konva.Easings.EaseInOut,
        x: newX,
        y: newY,
        onFinish: () => {
          if (layerRef.current) {
            layerRef.current.batchDraw();
          }
        }
      }).play();
    }
  };

  const handleSetColumns = (columns) => {
    setColumns(columns);
    setStartCalc(Date.now());
  };

  useEffect(() => {
    setContourColors(state.ProjectConfig.contourColors);
  }, [state.ProjectConfig.contourColors]);

  useEffect(() => {
    setContourValues(state.ProjectConfig.contourValues);
  }, [state.ProjectConfig.contourValues]);

  useEffect(() => {
    setAutoContourValues(state.ProjectConfig.autoContourValues);
  }, [state.ProjectConfig.autoContourValues]);


  useEffect(() => {
    const downHandler = (e) => {
      if (e.key === 'Control' || e.key === 'Shift') {
        setMultipleSelect(true);
      }
    }
    const upHandler = (e) => {
      if (e.key === 'Control' || e.key === 'Shift') {
        setMultipleSelect(false);
      }
    }
    window.addEventListener('keydown', downHandler);
    window.addEventListener('keyup', upHandler);
    return () => {
      window.removeEventListener('keydown', downHandler);
      window.removeEventListener('keyup', upHandler);
    };
  }, []);

  // Delete selected items on delete key press
  useEffect(() => {
    const handleKeyDown = (e) => {
      const activeElement = document.activeElement;
      const isTyping = activeElement.tagName === "INPUT" ||
        activeElement.tagName === "TEXTAREA" ||
        activeElement.isContentEditable;

      if (!isTyping && (e.key === "Delete" || e.key === "Backspace")) {

        const anyGridSelected = grids.some(grid => grid.selected);
        const anyColumnSelected = columns.some(column => column.selected);
        const anyMaskSelected = masks.some(mask => mask.selected);

        if (anyGridSelected || anyColumnSelected || anyMaskSelected) {
          setGrids((prevGrids) => {
            const newGrids = prevGrids.filter(grid => !grid.selected);
            return newGrids;
          });

          setColumns((prevColumns) => {
            const newColumns = prevColumns.filter(column => !column.selected);
            return newColumns;
          });

          setMasks((prevMasks) => {
            const newMasks = prevMasks.filter(mask => !mask.selected);
            return newMasks;
          });

          setStartCalc(Date.now());
        }
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [grids, columns, masks]);

  // ~~~~~~~~~~~~~~~~~~~~~~~~~
  // Undo/Redo Logic
  // ~~~~~~~~~~~~~~~~~~~~~~~~~

  const [history, setHistory] = React.useState([{ grids, columns, masks }]);
  const [currentStep, setCurrentStep] = React.useState(0);
  const isUndoRedoRef = React.useRef(false);

  const prevMaskDataRef = React.useRef({});
  const prevGridDataRef = React.useRef({});
  const prevColumnDataRef = React.useRef({});




  useEffect(() => {
    if (isUndoRedoRef.current) return;

    let newMasks = [...masks];

    const prevMaskIds = new Set(Object.keys(prevMaskDataRef.current));
    const currentMaskIds = new Set(newMasks.map(mask => mask.id));

    const maskChanged = newMasks.some((mask) => {
      const prevMaskData = prevMaskDataRef.current[mask.id];
      return (
        !prevMaskData ||
        prevMaskData.points !== JSON.stringify(mask.points) ||
        prevMaskData.rotation !== mask.rotation ||
        prevMaskData.scaleX !== mask.scaleX ||
        prevMaskData.scaleY !== mask.scaleY ||
        prevMaskData.x !== mask.x ||
        prevMaskData.y !== mask.y
      );
    });

    const maskAdded = newMasks.length > prevMaskIds.size;
    const maskDeleted = [...prevMaskIds].some(prevId => !currentMaskIds.has(prevId));

    if ((maskChanged || maskAdded || maskDeleted) && !isUndoRedoRef.current) {
      saveHistory();
    }

    prevMaskDataRef.current = newMasks.reduce((acc, mask) => {
      acc[mask.id] = {
        points: JSON.stringify(mask.points ?? []),
        rotation: mask.rotation ?? 0,
        scaleX: mask.scaleX ?? 1,
        scaleY: mask.scaleY ?? 1,
        x: mask.x ?? 0,
        y: mask.y ?? 0,
      };
      return acc;
    }, {});
  }, [masks]);

  useEffect(() => {
    if (isUndoRedoRef.current) return;

    let newGrids = [...grids];

    const prevGridIds = new Set(Object.keys(prevGridDataRef.current));
    const currentGridIds = new Set(newGrids.map(grid => grid.id));

    const gridChanged = newGrids.some((grid) => {
      const prevGridData = prevGridDataRef.current[grid.id];
      return (
        !prevGridData ||
        prevGridData.origin.x.start !== grid.origin.x.start ||
        prevGridData.origin.y.start !== grid.origin.y.start ||
        prevGridData.origin.x.length !== grid.origin.x.length ||
        prevGridData.origin.y.length !== grid.origin.y.length ||
        prevGridData.angle !== grid.angle ||
        prevGridData.xSpacing !== grid.xSpacing ||
        prevGridData.ySpacing !== grid.ySpacing ||
        prevGridData.edgeStart !== grid.edgeStart ||
        prevGridData.maskAll !== grid.maskAll ||
        prevGridData.maxSpacing !== grid.maxSpacing ||
        prevGridData.name !== grid.name ||
        prevGridData.obsAngle !== grid.obsAngle ||
        prevGridData.obsHeight !== grid.obsHeight ||
        prevGridData.selected !== grid.selected ||
        prevGridData.showResults !== grid.showResults ||
        prevGridData.type !== grid.type
      );
    });

    const gridAdded = newGrids.length > prevGridIds.size;
    const gridDeleted = [...prevGridIds].some(prevId => !currentGridIds.has(prevId));

    if ((gridChanged || gridAdded || gridDeleted) && !isUndoRedoRef.current) {
      saveHistory();
    }

    prevGridDataRef.current = newGrids.reduce((acc, grid) => {
      acc[grid.id] = {
        origin: {
          x: { start: grid.origin.x.start, length: grid.origin.x.length },
          y: { start: grid.origin.y.start, length: grid.origin.y.length },
        },
        angle: grid.angle ?? 0,
        xSpacing: grid.xSpacing ?? 1,
        ySpacing: grid.ySpacing ?? 1,
        gridStandard: grid.gridStandard ?? '',
      };
      return acc;
    }, {});
  }, [grids]);

  useEffect(() => {
    if (isUndoRedoRef.current) return;

    let newColumns = [...columns];

    const prevColumnIds = new Set(Object.keys(prevColumnDataRef.current));
    const currentColumnIds = new Set(newColumns.map(column => column.id));

    const columnChanged = newColumns.some((column) => {
      const prevColumnData = prevColumnDataRef.current[column.id];
      return (
        !prevColumnData ||
        prevColumnData.values.point.x !== column.values.point.x ||
        prevColumnData.values.point.y !== column.values.point.y ||
        prevColumnData.values.positionAngle !== column.values.positionAngle ||
        prevColumnData.values.cant !== column.values.cant ||
        prevColumnData.values.columnGrid !== column.values.columnGrid ||
        prevColumnData.values.dimFactor !== column.values.dimFactor ||
        prevColumnData.values.height !== column.values.height ||
        prevColumnData.values.outreach !== column.values.outreach ||
        prevColumnData.values.tilt !== column.values.tilt ||
        prevColumnData.values.maintenanceFactor !== column.values.maintenanceFactor ||
        prevColumnData.values.lanterns !== column.values.lanterns ||
        prevColumnData.isMast !== column.isMast ||
        prevColumnData.color !== column.color ||
        prevColumnData.name !== column.name ||
        prevColumnData.selected !== column.selected ||
        prevColumnData.id !== column.id
      );
    });

    const columnAdded = newColumns.length > prevColumnIds.size;
    const columnDeleted = [...prevColumnIds].some(prevId => !currentColumnIds.has(prevId));

    if ((columnChanged || columnAdded || columnDeleted) && !isUndoRedoRef.current) {
      saveHistory();
    }

    prevColumnDataRef.current = newColumns.reduce((acc, column) => {
      acc[column.id] = {
        color: column.color ?? '#000000',
        name: column.name ?? '',
        selected: column.selected ?? false,
        id: column.id ?? null,
        isMast: column.isMast ?? false,
        values: {
          point: {
            x: column.values.point.x ?? 0,
            y: column.values.point.y ?? 0,
          },
          positionAngle: column.values.positionAngle ?? 0,
          cant: column.values.cant ?? 0,
          columnGrid: column.values.columnGrid ?? 0,
          dimFactor: column.values.dimFactor ?? 1,
          height: column.values.height ?? 0,
          outreach: column.values.outreach ?? 0,
          tilt: column.values.tilt ?? 0,
          maintenanceFactor: column.values.maintenanceFactor ?? 1,
          lanterns: column.values.lanterns ?? [],
        },
      };
      return acc;
    }, {});
  }, [columns]);

  const saveHistory = () => {

    const state = {
      grids: JSON.parse(JSON.stringify(grids)),
      columns: JSON.parse(JSON.stringify(columns)),
      masks: JSON.parse(JSON.stringify(masks)),
    };

    setHistory((prevHistory) => {
      const newHistory = isUndoRedoRef.current
        ? [...prevHistory]
        : prevHistory.slice(0, currentStep + 1);

      newHistory.push(state);

      const maxHistory = 15;
      if (newHistory.length > maxHistory) newHistory.shift();

      setCurrentStep(newHistory.length - 1);

      return newHistory;
    });
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.ctrlKey || event.metaKey) {
        if (event.key === 'z') {
          undoAction();
        } else if (event.key === 'y') {
          redoAction();
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [history, currentStep]);


  const undoAction = () => {
    console.log("Undoing action...", currentStep);

    if (currentStep > 0) {
      isUndoRedoRef.current = true;

      const prevState = history[currentStep - 1];

      const deselectAll = (items) =>
        items.map((item) => ({ ...item, selected: false }));

      setMasks(deselectAll(prevState.masks));
      setGrids(deselectAll(prevState.grids));
      setColumns(deselectAll(prevState.columns));

      setCurrentStep((prevStep) => prevStep - 1);

      requestAnimationFrame(() => {
        isUndoRedoRef.current = false;
      });

      setStartCalc(Date.now());
    }
  };

  const redoAction = () => {
    console.log("Redoing action...", currentStep);
    if (currentStep < history.length - 1) {
      isUndoRedoRef.current = true;

      const nextState = history[currentStep + 1];
      setMasks(nextState.masks);
      setGrids(nextState.grids);
      setColumns(nextState.columns);

      setCurrentStep((prevStep) => {
        const newStep = prevStep + 1;
        return newStep;
      });

      requestAnimationFrame(() => {
        isUndoRedoRef.current = false;
      });

      setStartCalc(Date.now());
    }
  };

  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  // End of undo redo
  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

  const selectMask = (id) => {
    let tempMasks = [...masks];
    if (!multipleSelect) {
      const maskIndex = tempMasks.findIndex(mask => mask.id === id);
      if (maskIndex !== -1) {
        if (tempMasks[maskIndex].selected === false) {
          tempMasks = tempMasks.map((mask) => ({
            ...mask,
            selected: mask.id === id ? !mask.selected : false,
          }));
        } else {
          const selectedCount = tempMasks.filter(mask => mask.selected).length;
          if (selectedCount > 1) {
            tempMasks[maskIndex].selected = true;
            tempMasks = tempMasks.map((mask) => ({
              ...mask,
              selected: mask.id === id ? true : false,
            }));
          } else {
            tempMasks[maskIndex].selected = !tempMasks[maskIndex].selected;
          }
        }
      }
    } else {
      const maskIndex = tempMasks.findIndex(mask => mask.id === id);
      if (maskIndex !== -1) {
        tempMasks[maskIndex].selected = !tempMasks[maskIndex].selected;
      }
    }

    const updatedMask = tempMasks.find(mask => mask.id === id);
    if (updatedMask) updatedMask.locked = false;

    setMasks(tempMasks);
  };


  const deleteMask = (id) => {
    const updatedMasks = masks.filter(mask => mask.id !== id);
    setMasks(updatedMasks);
    setStartCalc(Date.now());
  };



  const lockMask = (id) => {
    const tempMasks = [...masks];
    const maskIndex = tempMasks.findIndex(mask => mask.id === id);
    if (maskIndex !== -1) {
      if (!tempMasks[maskIndex].locked) {
        tempMasks[maskIndex].selected = false;
      }
      tempMasks[maskIndex].locked = !tempMasks[maskIndex].locked;
    }
    setMasks(tempMasks);
  };


  const lockGrid = (id) => {
    const tempGrids = [...grids];
    const gridIndex = tempGrids.findIndex(grid => grid.id === id);
    if (gridIndex !== -1) {
      if (!tempGrids[gridIndex].locked) {
        tempGrids[gridIndex].selected = false;
      }
      tempGrids[gridIndex].locked = !tempGrids[gridIndex].locked;
    }
    setGrids(tempGrids);
  };




  const updateMaskFields = (updatedMask) => {
    setMasks((prevMasks) =>
      prevMasks.map((mask) => {
        if (mask.id !== updatedMask.id) return mask;

        const maskInChanged = updatedMask.hasOwnProperty("maskIn") && updatedMask.maskIn !== mask.maskIn;

        return {
          ...mask,
          ...updatedMask
        };
      })
    );
  };


  const updateMaskOrder = (newOrder) => {
    console.log("Mask old order", masks);
    console.log("Mask new order", newOrder);
    setMasks(newOrder);
  };


  const updateMask = (e, i, type, customPoints) => {
    var tempMasks = [...masks];
    var points = [];

    if (type !== "polygon") {
      var x = e.target.attrs.x;
      var y = e.target.attrs.y;
    }

    if (type === "rectangle") {
      const width = e.target.attrs.width;
      const height = e.target.attrs.height;
      const scaleX = e.target.attrs.scaleX;
      const scaleY = e.target.attrs.scaleY;
      const rotation = e.target.attrs.rotation;
      const opacity = e.target.attrs.opacity || 0.5;
      const x = e.target.attrs.x;
      const y = e.target.attrs.y;

      const rotationRadians = rotation * (Math.PI / 180);

      const originalPoints = [
        { x: x, y: y },
        { x: x + width * scaleX, y: y },
        { x: x + width * scaleX, y: y + height * scaleY },
        { x: x, y: y + height * scaleY }
      ];

      const rotatedPoints = originalPoints.map(point => {
        const translatedX = point.x - x;
        const translatedY = point.y - y;

        const rotatedX = translatedX * Math.cos(rotationRadians) - translatedY * Math.sin(rotationRadians);
        const rotatedY = translatedX * Math.sin(rotationRadians) + translatedY * Math.cos(rotationRadians);

        return { x: rotatedX + x, y: rotatedY + y };
      });

      tempMasks[i] = {
        ...tempMasks[i],
        points: rotatedPoints,
        x,
        y,
        width,
        height,
        scaleX,
        scaleY,
        rotation,
        opacity
      };
    } else if (type === "circle") {
      const radius = e.target.attrs.radius;
      const scaleX = e.target.attrs.scaleX;
      const scaleY = e.target.attrs.scaleY;
      const opacity = e.target.attrs.opacity;
      const rotation = e.target.attrs.rotation || 0;

      console.log("circle", e.target.attrs);
      points.push({ x: x, y: y });

      tempMasks[i] = {
        ...tempMasks[i],
        x,
        y,
        radius,
        scaleX,
        scaleY,
        points,
        opacity,
        rotation,
      };
    } else {
      tempMasks[i] = {
        ...tempMasks[i],
        points: customPoints,
      };
    }

    setMasks(tempMasks);
    setStartCalc(Date.now());
  };


  const addCustomMask = (customPoints, poly) => {
    var tempMasks = [...masks];
    var points = [];
    for (let k = 0; k < customPoints.length; k += 2) {
      points.push({ x: customPoints[k], y: customPoints[k + 1] });
    }
    points.push({ x: points[0].x, y: points[0].y });
    tempMasks.push({
      id: poly.id,
      type: "polygon",
      points,
      layer: tempMasks.length,
      name: "Mask #" + maskName,
      visible: true,
      color: null,
      selected: false,
      opacity: polyMaskIn ? 0.5 : 1,
      maskIn: polyMaskIn ? true : false,
      locked: false,
      polyClosed: poly.closed,
      polyFill: poly.fill,
      polyStroke: poly.stroke,
    });
    setMaskName(maskName + 1);
    setMasks(tempMasks);
    setPolyMaskIn(false)
    setStartCalc(Date.now());
  }


  const handleAddGrid = (e) => {
    e.preventDefault();
    var gridWidth = newGridWidth ?? 50;
    var gridHeight = newGridHeight ?? 50;
    var gridXStart = newGridXStart ?? 0;
    var gridYStart = newGridYStart ?? 0;

    const stageWidth = stageRef.current?.attrs.width ?? 0;
    const stageHeight = stageRef.current?.attrs.height ?? 0;
    const stageScaleX = stageRef.current?.attrs.scaleX ?? 1;
    const stageScaleY = stageRef.current?.attrs.scaleY ?? 1;
    const stageX = stageRef.current?.attrs.x ?? 0;
    const stageY = stageRef.current?.attrs.y ?? 0;

    gridXStart = Math.round(((stageWidth / 2 - stageX) / stageScaleX) * 100) / 100;
    gridYStart = Math.round(((stageHeight / 2 - stageY) / stageScaleY) * 100) / 100;

    gridXStart -= gridWidth / 2;
    gridYStart -= gridHeight / 2;

    console.log("called handleAddGrid", newGridWidth, newGridHeight, newGridXStart, newGridYStart);
    if (gridWidth > 0 && gridHeight > 0) {
      var newGrid = {
        selected: false,
        angle: 0,
        showResults: newGridShowResults,
        id: grids.length,
        locked: false,
        maskAll: "False",
        maskingLayer: "0",
        obsAngle: 0,
        obsHeight: 1.5,
        xSpacing: 1.5,
        ySpacing: 1.5,
        name: "Grid #" + (grids.length),
        color: "#00008B",
        gridStandard: selectedStandard,
        gridClass: selectedClass,
        visible: false,
        edgeStart: false,
        origin:
        {
          x: {
            start: gridXStart,
            length: gridWidth
          },
          y: {
            start: gridYStart,
            length: gridHeight
          },
          z: {
            start: 0,
            length: 0
          }
        },
        maxSpacing: 1.5,
        type: "Horizontal",
        verticalGridSide: "False"
      };
      var tempGrids = JSON.parse(JSON.stringify(grids));
      tempGrids.push(newGrid);
      setNewGridXStart(0);
      setNewGridYStart(0);
      setNewGridShowResults(false);
      setGrids(tempGrids);
      setStartCalc(Date.now());
    }
  }

  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  // Grid Standard

  const dropbox = [
    'EN13201:2015 Illuminance',
    // 'EN13201:2015 Luminance',
    'BS5489:2020 Illuminance',
    // 'IES RP-8-18',
    'CIE140 Illuminance',
    // 'CIE140 Luminance',
    // 'NZS1158:2005 Cat P Illuminance',
    //'NZS1158:2005 Cat V Luminance',
    // 'AUS Illuminance',
    // 'AUS Luminance',
  ]

  const [selectedStandard, setSelectedStandard] = useState(dropbox[0]);
  const [selectedClass, setSelectedClass] = useState("P1");

  const onStandardChange = (event) => {
    const standardId = event.target.value;
    setSelectedStandard(standardId);

    let illumTypeId = "Luminance";
    if (standardId.includes("Illuminance")) {
      illumTypeId = "Horizontal";
    }

    EdgeOrREST(null, 'SET_ROAD_CONFIG', (response) => onGetStandard(response, standardId), {
      postObject: { standardId, illumTypeId },
    });
  };

  const onGetStandard = (response, standardId) => {
    setSelectedClass(response.data.standard.CalcGridClass[0]);

    const updatedGrids = grids.map((grid) => ({
      ...grid,
      gridStandard: standardId,
      gridClass: response.data.standard.CalcGridClass[0],
    }));

    setGrids(updatedGrids);
  };

  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~


  const handleAddColumnWithXY = (event, x, y, currColor) => {
    event.preventDefault();
    var newColumn = {};
    // const stageWidth = stageRef.current?.attrs.width || 0;
    // const stageHeight = stageRef.current?.attrs.height || 0;

    // const stageScaleX = stageRef.current?.attrs.scaleX || 1;
    // const stageScaleY = stageRef.current?.attrs.scaleY || 1;
    // const stageX = stageRef.current?.attrs.x || 0;
    // const stageY = stageRef.current?.attrs.y || 0;

    var values = {
      point: {
        // x : Math.round((stageWidth / 2 - stageX) / stageScaleX * 100) / 100,  Add column to centre stage - uncomment code
        // y : Math.round((stageHeight / 2 - stageY) / stageScaleY * 100) / 100
        x: x,
        y: y
      },
      positionAngle: 0,
      columnConfiguration: "Single Sided Left",
      configuration: "None", // this is for the mast settings
      dimFactor: defaultColumnSettings[currValueId].dimFactor,
      columnGrid: defaultColumnSettings[currValueId].columnGrid,
      height: defaultColumnSettings[currValueId].height,
      maintenanceFactor: defaultColumnSettings[currValueId].maintenanceFactor,
      outreach: defaultColumnSettings[currValueId].outreach,
      cant: defaultColumnSettings[currValueId].cant,
      tilt: defaultColumnSettings[currValueId].tilt,
      luminaireId: currentLuminId != null ? currentLuminId : state.Plan?.selectedLuminaires[0],
    }

    newColumn.selected = false;
    newColumn.values = values;
    newColumn.name = "Column #" + (columns.length + 1);
    newColumn.color = currColor;
    newColumn.id = uuidv4();
    newColumn.group = "";
    if (columns.length > 0) {
      let arr = [...columns];
      arr.push(newColumn);
      setColumns(arr);
    } else {
      var arr = [];
      arr.push(newColumn);
      setColumns(arr);
    }

    setStartCalc(Date.now());
  }


  const handleAddMask = (event, maskType, maskIn) => {
    event.preventDefault();
    var newMask = {};
    newMask.id = uuidv4();
    newMask.type = maskType;
    newMask.points = [];
    newMask.layer = masks.length;
    newMask.name = "Mask #" + maskName;
    setMaskName(maskName + 1);
    newMask.visible = true; // For the name to be visible
    newMask.color = null;
    newMask.selected = false;
    newMask.opacity = maskIn ? 0.5 : 0.9;
    newMask.maskIn = maskIn;
    newMask.locked = false;
    newMask.scaleX = 1;
    newMask.scaleY = 1;
    newMask.rotation = 0;

    const stageWidth = stageRef.current?.attrs.width || 0;
    const stageHeight = stageRef.current?.attrs.height || 0;

    const stageScaleX = stageRef.current?.attrs.scaleX || 1;
    const stageScaleY = stageRef.current?.attrs.scaleY || 1;
    const stageX = stageRef.current?.attrs.x || 0;
    const stageY = stageRef.current?.attrs.y || 0;

    newMask.x = Math.round((stageWidth / 2 - stageX) / stageScaleX * 100) / 100;
    newMask.y = Math.round((stageHeight / 2 - stageY) / stageScaleY * 100) / 100;

    newMask.width = 50;
    newMask.height = 50;

    newMask.x -= newMask.width / 2;
    newMask.y -= newMask.height / 2;

    if (maskType === "circle") {
      newMask.radius = 25;
      newMask.x += newMask.radius;
      newMask.y += newMask.radius;
      newMask.points = [
        { x: newMask.x, y: newMask.y }
      ];
    }
    else {
      newMask.points = [
        { x: newMask.x, y: newMask.y },
        { x: newMask.x + newMask.width, y: newMask.y },
        { x: newMask.x + newMask.width, y: newMask.y + newMask.height },
        { x: newMask.x, y: newMask.y + newMask.height },
      ];
    }

    let arr = [...masks];
    arr.push(newMask);
    setMasks(arr);
    setStartCalc(Date.now());
  };


  const handleDrawLineMouseDown = (e) => {
    if (maskMode) {
      const pointX = (stageRef.current._changedPointerPositions[0].x - stageRef.current.attrs.x) / stageRef.current.attrs.scaleX;
      const pointY = (stageRef.current._changedPointerPositions[0].y - stageRef.current.attrs.y) / stageRef.current.attrs.scaleY;
      if (isDrawing && lines.length > 0) {
        console.log("lines", lines);
        let lastLine = lines[lines.length - 1];
        // Check if current mouse position is close to starting point
        const [startX, startY] = lastLine.points;
        if (Math.abs(pointX - startX) < (Math.max(1, 10 / stage.scale)) && Math.abs(pointY - startY) < (Math.max(1, 10 / stage.scale))) {
          // Close shape by adding starting point to end of points array
          // lastLine.points = lastLine.points.concat([startX, startY]);
          // lines.splice(lines.length - 1, 1, lastLine);
          setIsDrawing(false);
          setMaskMode(false);
          setCursorType('default');
          var poly = {
            id: uuidv4(),
            points: lines.concat()[0].points,
            fill: 'rgba(0, 210, 255, 0.5)',
            stroke: 'black',
            closed: true,
          };
          setLines([]);
          addCustomMask(lines.concat()[0].points, poly);
        } else {
          lastLine.points = lastLine.points.concat([pointX, pointY]);
          lines.splice(lines.length - 1, 1, lastLine);
          setLines(lines.concat());
        }
      } else {
        setLines([...lines, { points: [pointX, pointY] }]);
        setIsDrawing(true);
      }
    }
  };

  const handleMeasureMouseDown = (e) => {
    if (measureMode) {
      if (e.evt.button === 0) { // Left click
        const pointX = (stageRef.current._changedPointerPositions[0].x - stageRef.current.attrs.x) / stageRef.current.attrs.scaleX;
        const pointY = (stageRef.current._changedPointerPositions[0].y - stageRef.current.attrs.y) / stageRef.current.attrs.scaleY;
        setMeasureStartPoint({ x: pointX, y: pointY });
      } else if (e.evt.button === 2) { // Right click
        setMeasureStartPoint(null);
        setMeasureMode(false);
        setMeasureLine([]);
      }
    }
  };

  const handleMeasureMouseMove = (e) => {
    if (measureMode && measureStartPoint) {
      const stage = e.target.getStage();
      const pointerPosition = stage.getPointerPosition();
      if (pointerPosition) {
        const pointX = (pointerPosition.x - stage.attrs.x) / stage.attrs.scaleX;
        const pointY = (pointerPosition.y - stage.attrs.y) / stage.attrs.scaleY;
        const distance = Math.sqrt(Math.pow(pointX - measureStartPoint.x, 2) + Math.pow(pointY - measureStartPoint.y, 2));
        setMeasureDistance(distance);
        setMeasureLine([measureStartPoint.x, measureStartPoint.y, pointX, pointY]);
      }
    }
  };

  const [snack, setSnack] = React.useState({
    open: false
  });

  const handleSnackClose = () => {
    setSnack({
      ...snack,
      open: false
    });
  };

  const toggleLeftDrawer = () => {
    setLeftDrawerOpen(!leftDrawerOpen);
  };

  const toggleRightDrawer = () => {
    setRightDrawerOpen(!rightDrawerOpen);
  };

  const toggleLuminOpen = () => {
    setAddLuminOpen(!addLuminOpen);
  };

  const toggleLuminInfoOpen = () => {
    setLuminInfoOpen(!luminInfoOpen)
  }

  const toggleLuminSettingOpen = () => {
    setLuminSettingOpen(!luminSettingOpen)
  }

  const handleGetInfo = (event, id) => {
    setInfoLumin(state.Plan.selectedLuminaires[id]);
    dispatch(luminaireActions.UpdateLuminaireList({
      ...state.LuminaireCfg,
      selectedLuminaireIds: state?.Plan?.selectedLuminaires,
      selectedResultName: state?.Plan?.selectedLuminaireNames,
      selectedResultLuminId: state?.Plan?.selectedLuminaires[id],
    }));

    toggleLuminInfoOpen();
  }

  const handleAddLumin = (event) => {
    if (state?.Plan?.selectedLuminaires[numberOfLuminaires]) {
      setNumberOfLuminaires(numberOfLuminaires + 1);
      var tempName = luminName == "" ? state?.Plan?.selectedLuminaireNames ? state.Plan.selectedLuminaireNames[state.Plan.selectedLuminaireNames.length - 1] : "#" + numberOfLuminaires : luminName;
      setLuminNameList([...luminNameList, tempName]);
      setColors([...colors, "#212529"]);
      var defaultValue = {
        dimFactor: 1,
        columnGrid: 0,
        height: 6,
        maintenanceFactor: 1,
        outreach: 1,
        cant: 0,
        tilt: 0,
      };
      var temp = [...(defaultColumnSettings || [])];
      temp.push(defaultValue);
      setDefaultColumnSettings(temp);
      toggleLuminOpen();
      setLuminName("");
    } else {
      setSnack({
        open: true,
        message: "Please select a luminaire first",
        severity: 'warning'
      });
    }
  }

  const handleAddLuminClose = (event) => {
    setLuminName("");
    toggleLuminOpen();
  }

  const handleDeleteLumin = (event, id) => {
    if (!luminNameList || !colors || id < 0 || id >= luminNameList.length) {
      console.error("Invalid delete operation: List is empty or index is out of bounds.");
      return;
    }

    var temp = numberOfLuminaires - 1;

    // Remove item from luminNameList and colors
    var tempLuminNameList = [...luminNameList];
    var tempColors = [...colors];

    tempLuminNameList.splice(id, 1);
    tempColors.splice(id, 1);

    setLuminNameList(tempLuminNameList);
    setColors(tempColors);
    setNumberOfLuminaires(temp);

    // Ensure Redux state updates correctly
    var tempLumin = [...(state.Plan.selectedLuminaires || [])];
    var tempLuminColors = [...(state.Plan.selectedLuminaireColors || [])];
    var tempLuminNames = [...(state.Plan.selectedLuminaireNames || [])]; // ✅ Include names

    if (id < tempLumin.length) tempLumin.splice(id, 1);
    if (id < tempLuminColors.length) tempLuminColors.splice(id, 1);
    if (id < tempLuminNames.length) tempLuminNames.splice(id, 1); // ✅ Remove name

    dispatch(planActions.UpdatePlanLuminaires({
      selectedLuminaires: [...tempLumin],
      selectedLuminaireColors: [...tempLuminColors],
      selectedLuminaireNames: [...tempLuminNames]  // ✅ Include in update
    }));

    console.log("Updated Redux State:", {
      selectedLuminaires: tempLumin,
      selectedLuminaireColors: tempLuminColors,
      selectedLuminaireNames: tempLuminNames  // ✅ Corrected log output
    });
  };





  const toggleAddMode = (event) => {
    if (cursorType !== 'crosshair') {
      setCursorType('crosshair');
    } else {
      setCursorType('default');
    }
  }

  const handleAddColumnModeClick = (event) => {
    if (cursorType === 'crosshair' && event.button === 0 && !isDrawing) {
      const pointX = (stageRef.current._changedPointerPositions[0].x - stageRef.current.attrs.x) / stageRef.current.attrs.scaleX;
      const pointY = (stageRef.current._changedPointerPositions[0].y - stageRef.current.attrs.y) / stageRef.current.attrs.scaleY;

      if (markDetails.show && markDetails.snap && Array.isArray(markDetails.points) && isInSnapRange) {
        const nearestPoint = findClosestMarkPoint(markDetails.points, pointX, pointY);
        handleAddColumnWithXY(event, nearestPoint.x, nearestPoint.y, color);
      } else {
        handleAddColumnWithXY(event, pointX, pointY, color);
      }


    } else if (cursorType === 'crosshair' && event.button === 2) {
      toggleAddMode();
    }
  }

  const findClosestMarkPoint = (points, targetX, targetY) => {
    if (!Array.isArray(points) || points.length === 0) return null;

    let closestPoint = points[0];
    let minDistance = Math.hypot(points[0].x - targetX, points[0].y - targetY);

    for (let i = 1; i < points.length; i++) {
      const point = points[i];
      const dist = Math.hypot(point.x - targetX, point.y - targetY);

      if (dist < minDistance) {
        minDistance = dist;
        closestPoint = point;
      }
    }

    return closestPoint;
  };


  const handleAddColumnClick = (event, id) => {
    if (cursorType === 'default') {
      toggleAddMode();
      setCurrentLuminId(state?.Plan?.selectedLuminaires[id]);
      setColor(colors[id]);
      setCurrValueId(id);
    } else if (cursorType === 'crosshair') {
      toggleAddMode();
    }
  }

  const handleLuminSettingOpen = (event, id) => {
    setSettingId(id);
    setLuminName(luminNameList[id]);
    setColor(colors[id]);
    toggleLuminSettingOpen();
  }

  const handleAddSettingClose = (event) => {
    setLuminName("");
    toggleLuminSettingOpen();
  }

  const handleSaveLuminSetting = (event) => {
    var temp = [...defaultColumnSettings];
    temp[settingId] = defaultColumnSettingValues;
    setDefaultColumnSettings(temp);

    var newColors = [...colors];
    newColors[settingId] = color;
    setColors(newColors);

    columns.filter((item, index) => {
      if (item.values.luminaireId == state.Plan.selectedLuminaires[settingId]) {
        item.color = color;
      }
    });

    const newLuminNameList = [...luminNameList];
    newLuminNameList[settingId] = luminName;
    setLuminNameList(newLuminNameList);
    console.log(newLuminNameList, newColors, settingId);

    dispatch(planActions.UpdatePlanLuminaires({ selectedLuminaireColors: newColors }));

    setLuminName("");
    toggleLuminSettingOpen();
  }

  const handleMouseMove = (e) => {
    const stage = e.target.getStage();
    const pointerPosition = stage.getPointerPosition();
    if (pointerPosition) {
      setMousePosition({
        x: pointerPosition.x,
        y: pointerPosition.y,
      });
      const scaleX = stage.scaleX();
      const scaleY = stage.scaleY();
      const stageX = stage.x();
      const stageY = stage.y();
      var xScaler = realWorldWidth / imagePixelWidth;
      var yScaler = realWorldHeight / imagePixelHeight;
      const adjustedX = ((pointerPosition.x - stageX) / scaleX) * xScaler;
      const adjustedY = ((pointerPosition.y - stageY) / scaleY) * yScaler;
      setMouseCoords({ x: adjustedX, y: adjustedY });

      const furthestRadius = markDetails.step * markDetails.rings;
      const snapRadius = furthestRadius + markDetails.step * 5;

      const distance = Math.sqrt(Math.pow(adjustedX - markDetails.x, 2) + Math.pow(adjustedY - markDetails.y, 2));

      if (distance < snapRadius) {
        const closest = findClosestMarkPoint(markDetails.points, adjustedX, adjustedY);
        setPreviewPoint(closest);
        setIsInSnapRange(true);
      }
      else {
        setPreviewPoint(null);
        setIsInSnapRange(false);
      }



    }
  };

  const handleSelectDrawing = (id) => {
    setCurrentDrawingId(id);
    EdgeOrREST(null, 'LOAD_DRAWING', (response) => onLoadDrawing(true, response), id);
    dispatch(notificationActions.UpdateImageLoad({ imageLoad: true }));
  };

  const onLoadDrawing = (moveCamera, response = null) => {
    console.log("onLoadDrawing", response);
    if (response && response.svg) {
      onSetSvgImage(response.svg, 1, moveCamera);
    } else {
      onSetSvgImage(null, 1);
    }
    setSnack({
      open: true,
      message: "Drawing loaded successfully.",
      severity: 'success',
      action: 'upload completed'
    });

    setMetresPerPixelX(1);
    setMetresPerPixelY(1);
    dispatch(notificationActions.UpdateImageLoad({ imageLoad: false }));
    setValidDrawing(true);
  };

  const generateBlankSvg = (width, height) => {
    return `
      <svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}">
        <!-- Background rectangle -->
        <rect x="0" y="0" width="${width}" height="${height}" fill="transparent"/>
        
        <!-- Border rectangle -->
        <rect x="0" y="0" width="${width}" height="${height}" fill="none" stroke="gray" stroke-width="3"/>

        <!-- Text above the border -->
        <text x="${width / 2}" y="10" font-family="Arial" font-size="8" fill="black" text-anchor="middle">
          Default Working Area
        </text>
      </svg>`;
  };


  useEffect(() => {
    onLoadDrawing();
  }, []);

  const deleteDrawing = (id) => {
    EdgeOrREST(null, 'DELETE_DRAWING', onDeleteDrawing, id);
    setDrawings(drawings.filter((item) => item.id !== id));
  };


  const onDeleteDrawing = (response) => {
    if (response) {
      console.log(response);
    }
  }


  const handleContextMenu = (event, i, index) => {
    event.evt.preventDefault();
    setContextMenu(true);
    setContextMenuPosition({
      left: mousePosition.x + stageRef.current.attrs.container.offsetLeft,
      top: mousePosition.y + stageRef.current.attrs.container.offsetTop,
    });
    setContextMenuPointIndex(index);
    setContextMenuMaskIndex(i);
  };

  const handleClose = () => {
    setContextMenu(false);
    setContextMenuPointIndex(null);
  };

  const handleDuplicatePoint = () => {
    if (contextMenuPointIndex !== null && contextMenuMaskIndex !== null) {
      const newPoints = [...masks[contextMenuMaskIndex].points];
      const flatPoints = [];
      newPoints.slice(0, -1).forEach(point => {
        if (point && typeof point.x === "number" && typeof point.y === "number") {
          flatPoints.push(point.x, point.y);
        } else {
          console.log("Invalid point:", point);
        }
      });

      const x = flatPoints[contextMenuPointIndex * 2] + 5;
      const y = flatPoints[contextMenuPointIndex * 2 + 1] - 5;

      flatPoints.splice(contextMenuPointIndex * 2 + 2, 0, x, y);

      const xyPoints = [];
      for (let i = 0; i < flatPoints.length; i += 2) {
        xyPoints.push({ x: flatPoints[i], y: flatPoints[i + 1] });
      }
      if (xyPoints.length > 0) {
        xyPoints.push({ ...xyPoints[0] });
      }

      const newMask = { ...masks[contextMenuMaskIndex], points: xyPoints };
      const newMasks = [...masks];
      newMasks[contextMenuMaskIndex] = newMask;
      setMasks(newMasks);

    }
    handleClose();
  };

  const handleDeletePoint = () => {
    if (contextMenuPointIndex !== null && contextMenuMaskIndex !== null) {
      const newPoints = [...masks[contextMenuMaskIndex].points];
      const flatPoints = [];
      newPoints.slice(0, -1).forEach(point => {
        if (point && typeof point.x === "number" && typeof point.y === "number") {
          flatPoints.push(point.x, point.y);
        } else {
          console.log("Invalid point:", point);
        }
      });
      flatPoints.splice(contextMenuPointIndex * 2, 2);
      const xyPoints = [];
      for (let i = 0; i < flatPoints.length; i += 2) {
        xyPoints.push({ x: flatPoints[i], y: flatPoints[i + 1] });
      }

      if (xyPoints.length > 0) {
        xyPoints.push({ ...xyPoints[0] });
      }
      const newMask = { ...masks[contextMenuMaskIndex], points: xyPoints };
      const newMasks = [...masks];
      newMasks[contextMenuMaskIndex] = newMask;
      setMasks(newMasks);

    }
    handleClose();
  };

  const toggleMeasureMode = () => {
    setMeasureMode(!measureMode);
    setMeasureStartPoint(null);
    setMeasureDistance(0);
    setMeasureLine([]);
  };

  const handleAddMark = (markData) => {
    setMarkDetails(markData);
    setShowMark(markData.show)
  }

  const handleSaveMark = (markData) => {
    setMarkDetails(markData);
  }

  const handleMarkClose = (e) => {
    setMarkOpen(false);
  }

  const handleShowContours = (e) => {
    setShowContours(!showContours);
    dispatch(roadActions.AddToCurrentState({ showContours: !showContours }));
  }

  const handle3dView = () => {
    if (!image?.src) {
      setSnack({
        open: true,
        message: "Please load a drawing first",
        severity: 'warning'
      })
    } else {
      set3dView(!threeDView);
    }
  }

  const [confirmOpen, setConfirmOpen] = React.useState(false);
  const [comfirmItem, setConfirmItem] = React.useState(null);
  const [option, setOption] = React.useState('');
  const [filesData, setFilesData] = React.useState([]);
  const [fileDisable, setFileDisable] = React.useState(false);
  const [savingConfig, setSavingConfig] = React.useState(false);

  const handleOpenConfirm = (item, option) => {
    setConfirmOpen(true);
    setConfirmItem(item);
    setOption(option);
  }

  const handleConfirm = (e) => {
    if (option === 'Delete') {
      deleteConfig(comfirmItem.id);
    } else if (option === 'Update') {
      saveConfig(e, comfirmItem.id);
    } else if (option === 'Load') {
      handleLoadConfig(e, comfirmItem.id)
    } else if (option === 'Export') {
      handleExportConfig(e, comfirmItem.id)
    }
    handlConfirmClose();
  }
  const handlConfirmClose = () => {
    setConfirmOpen(false);
  }

  const handleChangeDefaultColumn = (e) => {
    var temp = e.target.name;
    setDefaultColumnSettingValues((prevColumn) => ({
      ...prevColumn,
      [temp]: e.target.value
    }));
  }

  const handleExportConfig = (e, id) => {
    EdgeOrREST(null, 'EXPORT_PLAN_SESSION', onExportConfig, { headers: { 'id': id } });
  }

  const handleSelectLRPS = (e) => {
    // console.log("handleImportLRS: " + e.target.files);

    for (const file of e.target.files) {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (event) => {
        // console.log("event.target.result", event.target.result);
        console.log("Base64 File Data:", event.target.result); // Data URL format
        const fileData = {
          fileName: file.name,
          content: event.target.result.split(',').pop(),
        };

        // Update state with new file data
        setFilesData((prevFiles) => [...prevFiles, fileData]);

      };
    }
  };

  const handleImportLRPS = (e) => {
    if (!filesData || filesData.length === 0) {
      setSnack({
        open: true,
        message: "No files selected",
        severity: 'warning'
      });
    } else {
      setFileDisable(true);
      var tempName = "";
      for (const fileData of filesData) {
        console.log("fileData", fileData);
        tempName = fileData.fileName.replace(/\.[^/.]+$/, "");
        EdgeOrREST(null, 'IMPORT_PLAN_SESSION', importLRPS, ({ data: fileData.content, fileName: tempName }));
      }
    }
  }

  const importLRPS = (response) => {
    console.log("import LRPS");
    if (response && response.status == '200') {
      getAllPlanSessions();
      setSnack({
        open: true,
        message: 'Configuration import success',
        severity: 'success'
      });
      setFileDisable(false);
    } else {
      setSnack({
        open: true,
        message: "Import files failed: " + response.message,
        severity: 'error'
      });
    }
  }


  const onExportConfig = (response) => {
    if (response && response.status == '200') {
      console.log("Export Config Response", response);
      var mediaType = "data:application/octet-stream;base64,";
      var a = document.createElement('a');
      a.href = mediaType + response.data.data;
      a.download = response.data.filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      setSnack({
        open: true,
        message: 'Export success',
        severity: 'success'
      });
    } else {
      setSnack({
        open: true,
        message: "Export failed",
        severity: 'error'
      });
    }
  }

  const handleExportColumnsAsCsv = () => {
    const luminIdList = state.Plan.selectedLuminaires;
    const columnValues = columns.map((column, id) => {
      const { columnConfiguration, luminaireId, ...restValues } = column.values;
      return { name: column.name, values: { ...restValues, luminaire: luminNameList[luminIdList.indexOf(column.values.luminaireId)] } };
    });

    console.log("columnValues", columnValues);
    if (columnValues.length === 0) {
      setSnack({
        open: true,
        message: "No columns to export",
        severity: 'warning'
      });
    } else {
      const csvContent = [
        ["Name", "x", "y", ...Object.keys(columnValues[0].values).filter(key => key !== "point")].join(","),
        ...columnValues.map(column => [
          column.name,
          column.values.point.x,
          column.values.point.y,
          ...Object.entries(column.values)
            .filter(([key]) => key !== "point")
            .map(([_, value]) => (typeof value === 'object' ? JSON.stringify(value) : value))
        ].join(","))
      ].join("\n");

      const blob = new Blob([csvContent], { type: 'text/csv' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'LR_Plan_columns.csv';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const handleSelectCsv = (e) => {
    for (const file of e.target.files) {
      let reader = new FileReader();
      reader.readAsText(file);
      reader.onload = (event) => {
        const csvContent = event.target.result;
        const rows = csvContent.split('\n').map(row => row.split(','));
        setFilesData((prevFiles) => [...prevFiles, { fileName: file.name, content: rows }]);
      };
    }
  };

  const handleImportCsv = () => {
    if (!filesData || filesData.length === 0) {
      setSnack({
        open: true,
        message: "No files selected",
        severity: 'warning'
      });
    } else {
      setFileDisable(true);
      filesData.forEach(fileData => {
        console.log("fileData", fileData);
        const rows = fileData.content;
        const headers = rows[0];
        const importedColumns = rows.slice(1).map(row => {
          const columnData = {};
          headers.forEach((header, index) => {
            if (header === "x" || header === "y") {
              columnData[header] = parseFloat(row[index]);
            } else if (header === "Name") {
              columnData.name = row[index];
            } else {
              try {
                columnData[header] = JSON.parse(row[index]);
              } catch {
                columnData[header] = row[index];
              }
            }
          });
          return columnData;
        });

        setColumns(prevColumns => {
          const updatedColumns = [...prevColumns];
          importedColumns.forEach(col => {
            const existingColumnIndex = updatedColumns.findIndex(existingCol => existingCol.name === col.name);
            if (existingColumnIndex !== -1) {
              // Update existing column
              updatedColumns[existingColumnIndex] = {
                ...updatedColumns[existingColumnIndex],
                values: {
                  point: { x: col.x, y: col.y },
                  ...Object.fromEntries(Object.entries(col).filter(([key]) => key !== "x" && key !== "y" && key !== "name"))
                }
              };
            } else {
              // Add new column
              updatedColumns.push({
                id: uuidv4(),
                name: col.name || `Imported Column`,
                values: {
                  point: { x: col.x, y: col.y },
                  ...Object.fromEntries(Object.entries(col).filter(([key]) => key !== "x" && key !== "y" && key !== "name"))
                },
                selected: false,
                color: color,
              });
            }
          });
          return updatedColumns;
        });
      });

      setSnack({
        open: true,
        message: "Columns imported successfully",
        severity: 'success'
      });
      setFileDisable(false);
    }
  };

  const handleCapture = () => {
    const stage = stageRef.current;
    if (stage) {
      const dataURL = stage.toDataURL({ pixelRatio: 2 });

      // Trigger download
      const link = document.createElement('a');
      link.download = 'canvas-capture.png';
      link.href = dataURL;
      link.click();
    }
  }

  const handleAddReportCaptureArea = (event) => {
    event.preventDefault();
    var newCaptureArea = {};
    newCaptureArea.id = uuidv4();
    newCaptureArea.points = [];
    newCaptureArea.name = "#" + reportCaptureAreas.length;
    newCaptureArea.visible = true; // For the name to be visible
    // newCaptureArea.color = null;
    newCaptureArea.selected = false;
    newCaptureArea.opacity = 0.5;
    newCaptureArea.locked = false;
    newCaptureArea.scaleX = 1;
    newCaptureArea.scaleY = 1;
    newCaptureArea.rotation = 0;

    const stageWidth = stageRef.current?.attrs.width || 0;
    const stageHeight = stageRef.current?.attrs.height || 0;

    const stageScaleX = stageRef.current?.attrs.scaleX || 1;
    const stageScaleY = stageRef.current?.attrs.scaleY || 1;
    const stageX = stageRef.current?.attrs.x || 0;
    const stageY = stageRef.current?.attrs.y || 0;

    newCaptureArea.x = Math.round((stageWidth / 2 - stageX) / stageScaleX * 100) / 100;
    newCaptureArea.y = Math.round((stageHeight / 2 - stageY) / stageScaleY * 100) / 100;

    newCaptureArea.width = 50;
    newCaptureArea.height = 50;

    newCaptureArea.x -= newCaptureArea.width / 2;
    newCaptureArea.y -= newCaptureArea.height / 2;

    newCaptureArea.points = [
      { x: newCaptureArea.x, y: newCaptureArea.y },
      { x: newCaptureArea.x + newCaptureArea.width, y: newCaptureArea.y },
      { x: newCaptureArea.x + newCaptureArea.width, y: newCaptureArea.y + newCaptureArea.height },
      { x: newCaptureArea.x, y: newCaptureArea.y + newCaptureArea.height },
    ];

    let arr = [...reportCaptureAreas];
    arr.push(newCaptureArea);
    setReportCaptureAreas(arr);
  };

  const selectReportCaptureArea = (id) => {
    let tempReportCaptureAreas = [...reportCaptureAreas];
    if (!multipleSelect) {
      const reportCaptureAreasIndex = tempReportCaptureAreas.findIndex(reportCaptureAreas => reportCaptureAreas.id === id);
      if (reportCaptureAreasIndex !== -1) {
        if (tempReportCaptureAreas[reportCaptureAreasIndex].selected === false) {
          tempReportCaptureAreas = tempReportCaptureAreas.map((reportCaptureArea) => ({
            ...reportCaptureArea,
            selected: reportCaptureArea.id === id ? !reportCaptureArea.selected : false,
          }));
        } else {
          const selectedCount = tempReportCaptureAreas.filter(reportCaptureAreas => reportCaptureAreas.selected).length;
          if (selectedCount > 1) {
            tempReportCaptureAreas[reportCaptureAreasIndex].selected = true;
            tempReportCaptureAreas = tempReportCaptureAreas.map((reportCaptureAreas) => ({
              ...reportCaptureAreas,
              selected: reportCaptureAreas.id === id ? true : false,
            }));
          } else {
            tempReportCaptureAreas[reportCaptureAreasIndex].selected = !tempReportCaptureAreas[reportCaptureAreasIndex].selected;
          }
        }
      }
    } else {
      const reportCaptureAreasIndex = tempReportCaptureAreas.findIndex(reportCaptureAreas => reportCaptureAreas.id === id);
      if (reportCaptureAreasIndex !== -1) {
        tempReportCaptureAreas[reportCaptureAreasIndex].selected = !tempReportCaptureAreas[reportCaptureAreasIndex].selected;
      }
    }

    const updatedReportCaptureArea = tempReportCaptureAreas.find(reportCaptureAreas => reportCaptureAreas.id === id);
    if (updatedReportCaptureArea) updatedReportCaptureArea.locked = false;

    setReportCaptureAreas(tempReportCaptureAreas);
  };


  const deleteReportCaptureArea = (id) => {
    const updatedReportCaptureAreas = reportCaptureAreas.filter(reportCaptureAreas => reportCaptureAreas.id !== id);
    setReportCaptureAreas(updatedReportCaptureAreas);
  };



  const lockReportCaptureArea = (id) => {
    const tempReportCaptureAreas = [...reportCaptureAreas];
    const reportCaptureAreaIndex = tempReportCaptureAreas.findIndex(reportCaptureArea => reportCaptureArea.id === id);
    if (reportCaptureAreaIndex !== -1) {
      if (!tempReportCaptureAreas[reportCaptureAreaIndex].locked) {
        tempReportCaptureAreas[reportCaptureAreaIndex].selected = false;
      }
      tempReportCaptureAreas[reportCaptureAreaIndex].locked = !tempReportCaptureAreas[reportCaptureAreaIndex].locked;
    }
    setReportCaptureAreas(tempReportCaptureAreas);
  };

  const updateReportCaptureArea = (e, i) => {
    var tempReportCaptureAreas = [...reportCaptureAreas];
    console.log("updateReportCaptureArea", tempReportCaptureAreas);
    console.log("e", e);
    const width = e.target.attrs.width;
    const height = e.target.attrs.height;
    const scaleX = e.target.attrs.scaleX;
    const scaleY = e.target.attrs.scaleY;
    const rotation = e.target.attrs.rotation;
    const opacity = e.target.attrs.opacity || 0.5;
    const x = e.target.attrs.x;
    const y = e.target.attrs.y;

    const rotationRadians = rotation * (Math.PI / 180);

    const originalPoints = [
      { x: x, y: y },
      { x: x + width * scaleX, y: y },
      { x: x + width * scaleX, y: y + height * scaleY },
      { x: x, y: y + height * scaleY }
    ];

    const rotatedPoints = originalPoints.map(point => {
      const translatedX = point.x - x;
      const translatedY = point.y - y;

      const rotatedX = translatedX * Math.cos(rotationRadians) - translatedY * Math.sin(rotationRadians);
      const rotatedY = translatedX * Math.sin(rotationRadians) + translatedY * Math.cos(rotationRadians);

      return { x: rotatedX + x, y: rotatedY + y };
    });

    tempReportCaptureAreas[i] = {
      ...tempReportCaptureAreas[i],
      points: rotatedPoints,
      x,
      y,
      width,
      height,
      scaleX,
      scaleY,
      rotation,
      opacity
    };

    setReportCaptureAreas(tempReportCaptureAreas);
    setStartCalc(Date.now());
  };

  //The Temp PDF Upload Function
  const handlePdfUpload = (event) => {
    const file = event.target.files[0];
    if (file && file.type === 'application/pdf') {
      const reader = new FileReader();

      reader.onload = () => {
        const base64PDF = reader.result.split(',')[1]; // Get only the base64 part

        const reportObject = {
          fileNames: file.name,
          data: base64PDF, // Assuming backend expects base64
          // Add any other required fields
        };

        EdgeOrREST(null, "UPLOAD_TEST_PDF", onUploadPDF, reportObject);
      };

      reader.readAsDataURL(file);
    } else {
      alert('Please upload a valid PDF file.');
    }
  };

  const onUploadPDF = (response) => {
    if (response.success) {
      console.log('Area calculation data:', response.data);
      // You can now update state, show results, or do something with the data
    } else {
      console.error('Failed to get area calculation:', response.error || response.message);
    }
  };


  return (
    <Page className={classes.root} title="Plan" style={{ 'minHeight': '85vh' }}>
      {/* toolbar */}
      <Drawer
        anchor="left"
        open={leftDrawerOpen}
        onClose={toggleLeftDrawer}
        variant='persistent'
        className={classes.drawer}
      // onContextMenu={handleContextMenu}
      >

        <Tooltip title="Undo" placement="right">
          <IconButton>
            <UndoIcon onClick={() => undoAction()} />
          </IconButton>
        </Tooltip>

        <Tooltip title="Redo" placement="right">
          <IconButton>
            <RedoIcon onClick={() => redoAction()} />
          </IconButton>
        </Tooltip>


        <Box
          style={{
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
          }}>
          <IconButton>
            <Tooltip title="Upload area image" placement="right">
              <AddPhotoAlternate onClick={(e) => setUploadAreaOpen(true)} />
            </Tooltip>
          </IconButton>
          <Draggable>
            <Dialog
              open={uploadAreaOpen}
              disableEscapeKeyDown
              disableEnforceFocus
              hideBackdrop
              BackdropProps={{ open: false }}
            >
              <DialogTitle>Add your area</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  <Typography>
                    Enter the dimensions of your Area
                  </Typography>
                  <TextField style={{ margin: '10px', padding: '4px' }} label={"width (m)"} name="width" onChange={onSetWidth} type="number" value={realWorldWidth} variant="outlined"
                    inputProps={{
                      step: 0.25
                    }}
                  />
                  <TextField style={{ margin: '10px', padding: '4px' }} label={"height (m)"} name="height" onChange={onSetHeight} type="number" value={realWorldHeight} variant="outlined"
                    inputProps={{
                      step: 0.25
                    }}
                  />
                  <Typography>
                    Export your additions as a SVG
                  </Typography>
                  <Typography>
                    Upload a DWG/DXF of your area
                  </Typography>
                </DialogContentText>
                <label>
                  <input accept="image/*" type="file" style={{ display: 'none' }}
                    onChange={(e) => onSetImage(e)} />
                  <IconButton color="primary" aria-label="upload picture" component="span">
                    <PhotoCamera />
                  </IconButton>
                </label>
                <label>
                  <input accept=".dwg,.dxf" type="file" style={{ display: 'none' }}
                    onChange={(e) => onUpload(e)} />
                  <Tooltip placement='top' title="Convert DWG to SVG">
                    <IconButton color="primary" aria-label="upload picture" component="span">
                      <img src={SVGConvertIcon} alt="Convert to SVG" style={{
                        width: 24,
                        height: 24
                      }} />
                      {/* <PhotoCamera /> */}
                    </IconButton>
                  </Tooltip>
                </label>
                <label>
                  <input accept=".dwg,.dxf" type="file" style={{ display: 'none' }}
                    onChange={(e) => UploadDWGToPNG(e)} />
                  <Tooltip placement='top' title="Convert DWG to PNG">
                    <IconButton color="primary" aria-label="upload picture" component="span" label="Convert DWG to PNG">
                      <img src={PNGConvertIcon} alt="Convert to PNG" style={{
                        width: 24,
                        height: 24
                      }} />
                      {/* <PhotoCamera /> */}
                    </IconButton>
                  </Tooltip>
                </label>
                <label>
                  <Select onChange={(e) => handleSelectDrawing(e)}>
                    {drawings?.map((drawing, index) => (
                      <MenuItem key={index} value={index}>
                        {drawing.name}
                      </MenuItem>
                    ))}
                  </Select>
                </label>
              </DialogContent>
              <Button onClick={(e) => setUploadAreaOpen(false)} color={"primary"} variant="contained"><Typography>Close</Typography></Button>
            </Dialog>
          </Draggable>
          <IconButton>
            <Tooltip title="Contours" placement="right">
              <VisibilityIcon onClick={(e) => setContourSettingsOpen(true)} />
            </Tooltip>
            <Dialog
              open={contourSettingsOpen}
              disableEscapeKeyDown
              disableEnforceFocus
              hideBackdrop
              BackdropProps={{ open: false }}
            >
              <DialogTitle>Contour Settings</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  <Typography>
                    Set your contour values
                  </Typography>
                </DialogContentText>
                <ContourValues />
                <FormControlLabel
                  control={<Checkbox onClick={() => handleShowContours()} checked={showContours} />}
                  label="Toggle Contours"
                />
              </DialogContent>
              <Button onClick={(e) => setContourSettingsOpen(false)} color={"primary"} variant="contained"><Typography>Close</Typography></Button>
            </Dialog>
          </IconButton>

          <IconButton onClick={(event) => {
            setMaskMode(false);
            setCursorType('default');
            setIsDrawing(false);
          }}>
            <Tooltip title="Default Mode" placement="right">
              <PanToolIcon />
            </Tooltip>
          </IconButton>

          <IconButton onClick={toggleMeasureMode}>
            <Tooltip title="Measure" placement="right">
              <Straighten />
            </Tooltip>
          </IconButton>

          <IconButton onClick={() => setMarkOpen(true)}>
            <Tooltip title="Mark" placement="right">
              <ControlPointIcon />
            </Tooltip>
          </IconButton>


          <AddMark open={markOpen} onClose={handleMarkClose} stageRef={stageRef} addMark={handleAddMark} saveMark={handleSaveMark} markData={markDetails} />

          <IconButton>
            <Tooltip title="3D View" placement="right">
              <ViewInArIcon onClick={(e) => handle3dView()} />
            </Tooltip>
          </IconButton>

          <ThreeDView open={threeDView} grids={grids} masks={masks} columns={columns}
            colorList={colors} luminaires={state.Plan.selectedLuminaires}
            realWidth={realWorldWidth} realHeight={realWorldHeight} image={image?.src}
            areaResults={areaResults}
          />

          <IconButton>
            <Tooltip title="Capture Canvas as Image" placement="right">
              <CameraAltIcon onClick={() => handleCapture()} />
            </Tooltip>
          </IconButton>
        </Box>
        <div style={{ marginTop: 'auto', textAlign: 'right' }}>
          <IconButton onClick={toggleLeftDrawer}>
            <Tooltip title="Hide Toolbar">
              <Typography>Close</Typography>
            </Tooltip>
          </IconButton>
        </div>
      </Drawer >
      {/* main drawing part */}
      <div id="planWrapper" ref={planRef} height={'100vh'}
        // onContextMenu={handleContextMenu}
        onMouseDownCapture={(e) => { handleAddColumnModeClick(e) }}
        style={{ cursor: cursorType }}
      >
        <Stage ref={stageRef} width={window.innerWidth * 0.86} height={window.innerHeight * 0.86}
          scaleX={stage.scale} scaleY={stage.scale} x={stage.x} y={stage.y} onMouseMove={(e) => {
            handleMouseMove(e);
            handleMeasureMouseMove(e);
          }}
          onWheel={handleWheel} onMouseDown={(e) => {
            handleDrawLineMouseDown(e);
            handleMeasureMouseDown(e);
          }} draggable={true} style={{ border: "1px solid lightgrey" }}>


          {image != null ?
            <Layer ref={imageLayerRef} style={{ border: '1px solid blue' }} onDragEnd={(e) => {


              console.log("updateImage", e);
              console.log("imageRef", imageRef);
              console.log("x", contourGridLayerRef.current.getAbsolutePosition().x);
              console.log("y", contourGridLayerRef.current.getAbsolutePosition().y);

              var tempGridStr = JSON.stringify(grids);
              var tempGrids = JSON.parse(tempGridStr);
              var xScaler = realWorldWidth / (imagePixelWidth * stageRef.current.attrs.scaleX);
              var yScaler = realWorldHeight / (imagePixelHeight * stageRef.current.attrs.scaleY);
              tempGrids[0].origin.x.start = e.target.attrs.x * xScaler;
              tempGrids[0].origin.y.start = e.target.attrs.y * yScaler;
              setMetresPerPixelX(xScaler);
              setMetresPerPixelY(yScaler);
              setGrids(tempGrids);
              // console.log("imageLayerRef x",contourImageRef.current.attrs.x = contourGridLayerRef.current.getAbsolutePosition().x); 
              // console.log("imageLayerRef y",contourImageRef.current.attrs.x = contourGridLayerRef.current.getAbsolutePosition().y); 
              contourImageRef.current.attrs.width = contourGridLayerRef.current.attrs.width;
              contourImageRef.current.attrs.height = contourGridLayerRef.current.attrs.height;
              contourImageRef.current.attrs.x = contourGridLayerRef.current.getAbsolutePosition().x - (imageLayerRef.current.getAbsolutePosition().x * stage.scale);
              contourImageRef.current.attrs.y = contourGridLayerRef.current.getAbsolutePosition().y - (imageLayerRef.current.getAbsolutePosition().y * stage.scale);

            }}>
              <Image ref={imageRef} x={0} y={0} image={image} />
            </Layer>
            :
            null
          }


          {contourImage != null && contourGridLayerRef != null && contourGridLayerRef.current != null && showContours ?
            <Layer>
              <Image
                ref={contourImageRef}
                image={contourImage}
                height={contourGridLayerRef.current.attrs.height}
                width={contourGridLayerRef.current.attrs.width}
                x={contourGridLayerRef.current.getAbsolutePosition().x - imageLayerRef.current.getAbsolutePosition().x}
                y={contourGridLayerRef.current.getAbsolutePosition().y - imageLayerRef.current.getAbsolutePosition().y}
              />
            </Layer>
            : null
          }

          <Layer id="gridLayer">
            <Rect ref={contourGridLayerRef} sides={10}
              // x={grid.origin.x.start * (image.naturalWidth / realWorldWidth)}
              // y={grid.origin.y.start * (image.naturalHeight / realWorldHeight)}
              // width={realWorldWidth * (image.naturalWidth / realWorldWidth)}
              // height={realWorldHeight * (image.naturalHeight / realWorldHeight)}
              x={visualGrid.x}
              y={visualGrid.y}
              width={visualGrid.width}
              height={visualGrid.height}
              fill="lightblue"
              opacity={0}
              shadowEnabled={false} draggable={false}
            // onDragEnd={(e) => {
            //   updateGrid(e);
            // }}
            // onTap={(e) => {
            //   onSelectGrid();
            // }}
            // onClick={(e) => {
            //   onSelectGrid();
            // }}
            />

            {/* <Transformer ref={gridTrRef} resizeEnabled={true}
                  onTransformEnd={(e) => {
                    if (e.currentTarget.parent.attrs.id == "gridLayer") {
                      console.log("transformed grid", e.currentTarget.children[0]);
                      var jsontemp = JSON.stringify(grid);
                      var tempGrid = JSON.parse(jsontemp);
                      var xScaler = realWorldWidth / (imagePixelWidth * stageRef.current.attrs.scaleX);
                      var yScaler = realWorldHeight / (imagePixelHeight * stageRef.current.attrs.scaleY);
                      tempGrid.origin.x.length = e.currentTarget.children[0].attrs.width * xScaler;
                      tempGrid.origin.y.length = e.currentTarget.children[0].attrs.height * yScaler;
                      setGrid(tempGrid);
                      setMetresPerPixelX(xScaler);
                      setMetresPerPixelY(yScaler);
                    }
                  }}
                /> */}
          </Layer>

          {showMark && markDetails ? (
            <Mark markDetails={markDetails} stageScale={stage.scale} saveMark={handleSaveMark} />
          ) : null}

          {previewPoint && markDetails.snap && cursorType === "crosshair" && !maskMode && (
            <Layer>
              <Circle
                x={previewPoint.x}
                y={previewPoint.y}
                radius={Math.max(0.25, 10 / stage.scale)}
                fill="rgba(65, 65, 65, 0.5)"
                stroke="gray"
                strokeWidth={Math.max(0.1, 3 / stage.scale)}
                listening={false}
              />
            </Layer>
          )}

          {grids?.map((grid, i) => {
            return <CanvasGrid i={grid.id} grid={grid}
              updateGrid={updateGrid} selectGrid={selectGrid} state={state} planRef={planRef} selected={grid.selected}
              gridScaleX={gridScaleX} gridScaleY={gridScaleY} areaResults={areaResults} showResults={grid.showResults}
              stageScale={stage.scale}
            />
          })}

          <Layer ref={layerRef}>
            {columns?.map((column, i) => (
              <ColumnHandler
                key={column.id}
                i={i}
                values={column.values}
                doAreaCalc={doAreaCalc}
                updateColumn={updateColumn}
                selectColumn={selectColumn}
                state={state}
                planRef={planRef}
                selected={column.selected}
                gridScaleX={gridScaleX}
                gridScaleY={gridScaleY}
                color={column.color}
                onRotate={updateRotate}
                name={column.name}
                id={column.id}
                stageScale={stage.scale}
                focusColumn={focusColumn}
                lanterns={column.values.lanterns}
                mountingType={column.values.mountingType}
                isMast={column.isMast}
                positionAngle={column.values.positionAngle}
                colorList={colors}
                luminaires={state.Plan.selectedLuminaires}
                updateLanternRotation={updateLanternRotation}
                updateLanternBeamEndpoint={updateLanternBeamEndpoint}
                updateLanterns={updateLanterns}
                polarInfo={polarInfo}
                fetchPolarInfo={fetchPolarInfo}
              />
            ))}
          </Layer>

          {/* masks */}
          {masks.map((mask, i) => {
            if (mask.type === "polygon") {
              return (
                <CustomMask
                  key={mask.id || i}
                  i={i}
                  selectMask={selectMask}
                  mask={mask}
                  maskList={masks}
                  handleContextMenu={handleContextMenu}
                  updateMask={updateMask}
                  stageScale={stage.scale}
                />
              );
            } else if (mask.type !== "polygon") {
              return (
                <Mask
                  key={mask.id || i}
                  i={i}
                  updateMask={updateMask}
                  selectMask={selectMask}
                  maskType={mask.type}
                  state={state}
                  selected={mask.selected}
                  mask={mask}
                  maskList={masks}
                  stageScale={stage.scale}
                />
              );
            }

            console.warn(`No corresponding poly for mask at index ${i}:`, mask);
            return null;
          })}

          {reportCaptureAreas?.map((reportCapture, i) => {
            return (
              <ReportCapture
                key={reportCapture.id || i}
                i={i}
                selectReportCapture={selectReportCaptureArea}
                reportCapture={reportCapture}
                updateReportCapture={updateReportCaptureArea}
                stageScale={stage.scale}
                selected={reportCapture.selected}
                state={state}
              />
            );
          })}


          <Layer ref={linesLayerRef}>
            {lines?.map((line, i) => (
              <Line
                key={i}
                points={line.points}
                stroke="black"
                strokeWidth={Math.max(0.33, 3 / stage.scale)}
                opacity={0.5}
                lineCap="round"
                lineJoin="miter"
                globalCompositeOperation={
                  // line.tool === 'eraser' ? 'destination-out' : 'source-over'
                  "source-over"
                }
              />
            ))}
          </Layer>


          <Layer>
            {measureLine.length > 0 && (
              <Line
                points={measureLine}
                stroke="black"
                strokeWidth={2 / stage.scale}
                dash={[10 / stage.scale, 5 / stage.scale]}
              />
            )}
          </Layer>

          {showContours && <ContourMapLayer
            gridValues={contourGridResults}
            gridRect={grids[0]} scale={stage.scale}
            contourValues={contourValues}
            autoContourValues={autoContourValues}
            contourColors={contourColors}
          />}
        </Stage>

        <Menu
          keepMounted
          open={contextMenu}
          onClose={handleClose}
          anchorReference="anchorPosition"
          anchorPosition={
            contextMenuPosition
          }
        >
          <MenuItem onClick={handleDuplicatePoint}>Duplicate</MenuItem>
          <MenuItem onClick={handleDeletePoint}>Delete</MenuItem>
        </Menu>

      </div>
      {/* Right hand column */}
      <Grid
      // onContextMenu={handleContextMenu}
      >
        <Draggable style={{ width: '350px' }}>
          <Dialog
            open={addLuminOpen}
            disableEscapeKeyDown
            disableEnforceFocus
            hideBackdrop
            BackdropProps={{ open: false }}
            style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}
          >
            <DialogTitle>Add Luminaire</DialogTitle>
            <DialogContent>
              <DialogContentText>
                <TextField
                  style={{ margin: '10px' }}
                  onChange={(e) => setLuminName(e.target.value)}
                  type="text"
                  value={luminName}
                  variant="outlined"
                  label="Custom Luminaire Name"
                  autoFocus
                />
                <LuminCard index={numberOfLuminaires} page={"plan"} />
              </DialogContentText>
            </DialogContent>
            <div style={{ textAlign: "right", margin: 10 }}>
              <Button
                style={{ margin: '10px' }}
                onClick={(e) => handleAddLumin(e)}
                color={"primary"}
                variant="contained">
                <Typography>Add</Typography>
              </Button>
              <Button
                style={{ margin: '10px' }}
                onClick={(e) => handleAddLuminClose(e)}
                color={"primary"}
                variant="contained">
                <Typography>Cancel</Typography>
              </Button>
            </div>
          </Dialog>
        </Draggable>
        <Draggable style={{ width: '350px' }}>
          <Dialog
            open={luminInfoOpen}
            disableEscapeKeyDown
            disableEnforceFocus
            hideBackdrop
            BackdropProps={{ open: false }}
            style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}
          >
            <DialogTitle>Luminaire Info</DialogTitle>
            <DialogContent>
              <DialogContentText>
                <PhotometricInformation index={infoLumin} />
              </DialogContentText>
            </DialogContent>
            <div style={{ textAlign: "right", margin: 10 }}>
              <Button
                onClick={toggleLuminInfoOpen}
                color={"primary"}
                variant="contained">
                <Typography>Close</Typography>
              </Button>
            </div>
          </Dialog>
        </Draggable>
        <Draggable style={{ width: '350px' }}>
          <Dialog
            open={luminSettingOpen}
            disableEscapeKeyDown
            disableEnforceFocus
            hideBackdrop
            BackdropProps={{ open: false }}
            style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}
          >
            <DialogTitle>Luminaire Setting</DialogTitle>
            <DialogContent>
              <DialogContentText>
                <TextField
                  style={{ margin: '10px' }}
                  onChange={(e) => setLuminName(e.target.value)}
                  type="text"
                  value={luminName}
                  variant="outlined"
                  label="Custom Luminaire Name"
                  autoFocus
                />
                <Typography>Default Setting for columns</Typography>
                <TextField
                  label="Dim"
                  value={defaultColumnSettingValues?.dimFactor}
                  onChange={(e) => handleChangeDefaultColumn(e)}
                  style={{ margin: '10px' }}
                  variant="outlined"
                  type="number"
                  name="dimFactor"
                />
                <TextField
                  label="Height"
                  value={defaultColumnSettingValues?.height}
                  onChange={(e) => handleChangeDefaultColumn(e)}
                  style={{ margin: '10px' }}
                  variant="outlined"
                  type="number"
                  name="height"
                />
                <TextField
                  label="Maintenance Factor"
                  value={defaultColumnSettingValues?.maintenanceFactor}
                  onChange={(e) => handleChangeDefaultColumn(e)}
                  style={{ margin: '10px' }}
                  variant="outlined"
                  type="number"
                  name="maintenanceFactor"
                />
                <TextField
                  label="Outreach"
                  value={defaultColumnSettingValues?.outreach}
                  onChange={(e) => handleChangeDefaultColumn(e)}
                  style={{ margin: '10px' }}
                  variant="outlined"
                  type="number"
                  name="outreach"
                />
                <TextField
                  label="Cant"
                  value={defaultColumnSettingValues?.cant}
                  onChange={(e) => handleChangeDefaultColumn(e)}
                  style={{ margin: '10px' }}
                  variant="outlined"
                  type="number"
                  name="cant"
                />
                <TextField
                  label="Tilt"
                  value={defaultColumnSettingValues?.tilt}
                  onChange={(e) => handleChangeDefaultColumn(e)}
                  style={{ margin: '10px' }}
                  variant="outlined"
                  type="number"
                  name="tilt"
                />
                <Typography>Color</Typography>
                <HexColorPicker color={color} onChange={(e) => setColor(e)} />
                Selected Color: {color}
              </DialogContentText>
            </DialogContent>
            <div style={{ textAlign: "right", margin: 10 }}>
              <Button
                onClick={(e) => handleSaveLuminSetting(e)}
                color={"primary"}
                variant="contained">
                <Typography>Save</Typography>
              </Button>
              <Button
                onClick={(e) => handleAddSettingClose(e)}
                color={"primary"}
                variant="contained">
                <Typography>Close</Typography>
              </Button>
            </div>
          </Dialog>
        </Draggable>
        <Drawer
          anchor="right"
          open={rightDrawerOpen}
          onClose={toggleRightDrawer}
          variant='persistent'
          className={classes.drawer}
        >
          <Box
            style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', width: '350px', height: '100%' }}
          >

            <Accordion
              style={{
                border: "1px solid rgba(0, 0, 0, .225)",
                boxShadow: "none",
                "&:not(:last-child)": {
                  borderBottom: 0,
                },
                "&:before": {
                  display: "none",
                }
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography>Luminaire</Typography>
              </AccordionSummary>
              <IconButton onClick={(e) => toggleLuminOpen()}>
                <AddIcon />
              </IconButton>
              {/* {console.log("Name list", luminNameList)} */}
              <AccordionDetails style={{ display: 'flex', flexDirection: 'column', backgroundColor: "white" }}>
                {luminNameList == [] ? <></> : luminNameList?.map((luminName, id) => (
                  <List>
                    <ListItem>
                      <ListItemText
                        primary={
                          <Tooltip title={luminName}>
                            <Typography
                              noWrap
                              sx={{
                                maxWidth: "150px",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                display: "block",
                              }}
                              style={{ userSelect: 'none' }}
                            >
                              {luminName && luminName.length > 17 ? `${luminName.slice(0, 16)}...` : luminName}
                            </Typography>
                          </Tooltip>
                        }
                        style={{ color: colors[id] }}
                      />
                      <ListItemSecondaryAction>
                        <Tooltip title="Add column">
                          <IconButton edge="end" aria-label="Add column" onClick={(e) => handleAddColumnClick(e, id)}>
                            <AddIcon />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Setting">
                          <IconButton edge="end" aria-label="Setting" onClick={(e) => handleLuminSettingOpen(e, id)}>
                            <SettingsIcon />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Info">
                          <IconButton edge="end" aria-label="Info" onClick={(e) => handleGetInfo(e, id)}>
                            <InfoIcon />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Delete">
                          <IconButton edge="end" aria-label="delete" onClick={(e) => handleDeleteLumin(e, id)}>
                            <DeleteIcon />
                          </IconButton>
                        </Tooltip>
                      </ListItemSecondaryAction>
                    </ListItem>
                  </List>
                ))}
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel3a-content"
                id="panel3a-header"
              >
                <Typography>Column</Typography>
              </AccordionSummary>
              <Tooltip title="Export Columns as csv">
                <Button onClick={handleExportColumnsAsCsv} color="primary" variant="contained" style={{ margin: '20px' }}>
                  <Typography>Export Columns</Typography>
                </Button>
              </Tooltip>
              <Typography
                variant="caption"
                color="textSecondary"
                style={{
                  marginLeft: '10px',
                  fontSize: '0.7rem',
                  whiteSpace: 'nowrap',
                  cursor: 'default',
                }}
              >

              </Typography>
              <input
                disabled={fileDisable}
                type="file"
                id="contained-button-file"
                onChange={(e) => handleSelectCsv(e)}
                multiple
                className={classes.input}
                accept=".csv"
                style={{
                  marginLeft: '10px',
                }}
              />
              <Button
                color="primary"
                variant="contained"
                component="span"
                onClick={() => {
                  handleImportCsv();
                }}
                className="MuiButton-textPrimary">
                Import
              </Button>

              <TextField
                fullWidth
                variant="standard"
                placeholder={"Search Columns..."}
                size="small"
                value={columnSearchTerm}
                onChange={handleColumnSearchChange}
                sx={{
                  "& fieldset": { border: "none" },
                  "& .MuiInput-underline:before": { borderBottom: "1px solid black" },
                  "& .MuiInput-underline:hover:before": { borderBottom: "1px solid black" },
                  "& .MuiInput-underline:after": { borderBottom: "2px solid black" },
                }}
                style={{
                  margin: "12px auto",
                  width: "80%",
                  display: "flex",
                  justifyContent: "center",
                }}
              />

              <AccordionDetails>
                <ColumnEditor deleteColumn={deleteColumn} selectColumn={selectColumn} columnList={columns} columns={filteredColumns} setColumns={handleSetColumns} focusColumn={focusColumn}
                  realWorldHeight={realWorldHeight} realWorldWidth={realWorldWidth} imagePixelWidth={imagePixelWidth} imagePixelHeight={imagePixelHeight} doAreaCalc={doAreaCalc}
                />
              </AccordionDetails>
            </Accordion>



            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2a-content"
                id="panel2a-header"
              >
                <Typography>Grid</Typography>
              </AccordionSummary>

              <div style={{ margin: '10px 0', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <TextField
                  style={{ width: '270px', marginBottom: '10px' }}
                  label="Standard"
                  name="calcStandard"
                  onChange={(e) => onStandardChange(e)}
                  select
                  SelectProps={{ native: true }}
                  value={selectedStandard}
                  variant="outlined"
                  inputProps={{
                    style: {
                      height: '20px',
                      padding: '5px',
                      textAlign: 'center'
                    }
                  }}
                >
                  {dropbox.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </TextField>

                <div style={{
                  display: 'flex',
                  gap: '8px',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}>
                  <TextField
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, '').slice(0, 4);
                      setNewGridWidth(value);
                    }}
                    onFocus={(e) => e.target.select()}
                    onBlur={(e) => {
                      const val = e.target.value;
                      e.target.value = '';
                      e.target.value = val;
                    }}
                    type="text"
                    value={newGridWidth}
                    variant="outlined"
                    label="Width"
                    inputProps={{
                      maxLength: 4,
                      style: { height: '20px', padding: '5px', textAlign: 'center' }
                    }}
                    style={{ width: '100px' }}
                  />

                  <TextField
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, '').slice(0, 4);
                      setNewGridHeight(value);
                    }}
                    onFocus={(e) => e.target.select()}
                    onBlur={(e) => {
                      const val = e.target.value;
                      e.target.value = '';
                      e.target.value = val;
                    }}
                    type="text"
                    value={newGridHeight}
                    variant="outlined"
                    label="Height"
                    inputProps={{
                      maxLength: 4,
                      style: { height: '20px', padding: '5px', textAlign: 'center' }
                    }}
                    style={{ width: '100px' }}
                  />

                  <Tooltip title="Add grid">
                    <IconButton disabled={grids[0].id != 0}>
                      <AddIcon onClick={(e) => handleAddGrid(e)} />
                    </IconButton>
                  </Tooltip>
                </div>
              </div>


              <TextField
                fullWidth
                variant="standard"
                placeholder={"Search Grids..."}
                size="small"
                value={gridSearchTerm}
                onChange={handleGridSearchChange}
                sx={{
                  "& fieldset": { border: "none" },
                  "& .MuiInput-underline:before": { borderBottom: "1px solid black" },
                  "& .MuiInput-underline:hover:before": { borderBottom: "1px solid black" },
                  "& .MuiInput-underline:after": { borderBottom: "2px solid black" },
                }}
                style={{
                  margin: "12px auto",
                  width: "80%",
                  display: "flex",
                  justifyContent: "center",
                }}
              />

              <AccordionDetails>
                <GridEditor
                  deleteGrid={deleteGrid}
                  selectGrid={selectGrid}
                  lockGrid={lockGrid}
                  grids={filteredGrids}
                  gridResults={areaResults}
                  updateGrid={updateGrid}
                  updateGridOnSave={updateGridOnSave}
                  updateGridResults={updateGridResults}
                  setSnack={setSnack}
                />

              </AccordionDetails>
            </Accordion>



            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel4a-content"
                id="panel4a-header"
              >
                <Typography>Mask</Typography>
              </AccordionSummary>

              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 16px' }}>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <IconButton
                    onClick={(event) => handleAddMask(event, "circle", true)}
                    onContextMenu={(event) => handleAddMask(event, "circle", false)}
                  >
                    <Tooltip title="Circle mask">
                      <PanoramaFishEyeIcon />
                    </Tooltip>
                  </IconButton>

                  <IconButton
                    onClick={(event) => handleAddMask(event, "rectangle", true)}
                    onContextMenu={(event) => handleAddMask(event, "rectangle", false)}
                  >
                    <Tooltip title="Rectangle/Square mask">
                      <RectangleIcon />
                    </Tooltip>
                  </IconButton>

                  <IconButton
                    disabled={maskMode}
                    onClick={() => {
                      setMaskMode(!maskMode);
                      setIsDrawing(!isDrawing);
                      setCursorType(cursorType == 'crosshair' ? 'default' : 'crosshair');
                      setPolyMaskIn(true)
                    }}
                    onContextMenu={(e) => {
                      e.preventDefault();
                      setMaskMode(!maskMode);
                      setIsDrawing(!isDrawing);
                      setCursorType(cursorType == 'crosshair' ? 'default' : 'crosshair');
                      setPolyMaskIn(false)
                    }}
                  >
                    <Tooltip title="Polygon Mask">
                      <TimelineIcon />
                    </Tooltip>
                  </IconButton>
                </div>

                {/* <Tooltip title="Drag and drop to reorder, Bottom is the highest layer" placement="top-start">
                  <InfoOutlinedIcon />
                </Tooltip> */}
              </div>

              <TextField
                fullWidth
                variant="standard"
                placeholder={"Search Masks..."}
                size="small"
                value={maskSearchTerm}
                onChange={handleMaskSearchChange}
                sx={{
                  "& fieldset": { border: "none" },
                  "& .MuiInput-underline:before": { borderBottom: "1px solid black" },
                  "& .MuiInput-underline:hover:before": { borderBottom: "1px solid black" },
                  "& .MuiInput-underline:after": { borderBottom: "2px solid black" },
                }}
                style={{
                  margin: "12px auto",
                  width: "80%",
                  display: "flex",
                  justifyContent: "center",
                }}
              />

              <AccordionDetails>
                <MaskEditor
                  deleteMask={deleteMask}
                  selectMask={selectMask}
                  updateMaskOrder={updateMaskOrder}
                  updateMask={updateMaskFields}
                  lockMask={lockMask}
                  masks={filteredMasks}
                  maskList={masks}
                />
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel6a-content"
                id="panel6a-header"
              >
                <Typography>Saved Configurations</Typography>
              </AccordionSummary>
              <TextField
                style={{ margin: '10px' }}
                onChange={(e) => setConfigName(e.target.value)}
                type="text"
                value={configName}
                variant="outlined"
                label="Configuration Name"
                autoFocus
              />
              <Tooltip title="Save Current Config">
                <Button disabled={savingConfig} onClick={(e) => saveConfig(e, 0)} color="primary" variant="contained" style={{ margin: '20px' }}>
                  <Typography>Save</Typography>
                </Button>
              </Tooltip>
              <Typography
                variant="caption"
                color="textSecondary"
                style={{
                  marginLeft: '10px',
                  fontSize: '0.7rem',
                  whiteSpace: 'nowrap',
                  cursor: 'default',
                }}
              >
                {currentDrawingId && drawings ? `Using Drawing file: ${drawings?.find(drawing => drawing.id === currentDrawingId)?.name}` : ''}
              </Typography>
              <input
                disabled={fileDisable}
                type="file"
                id="contained-button-file"
                onChange={(e) => handleSelectLRPS(e)}
                multiple
                className={classes.input}
                accept=".LRPS"
                style={{
                  marginLeft: '10px',
                }}
              />
              <Button
                color="primary"
                variant="contained"
                component="span"
                onClick={() => {
                  handleImportLRPS();
                }}
                className="MuiButton-textPrimary">
                Import
              </Button>

              <AccordionDetails>
                <TableContainer>
                  <Table>
                    {!savedConfigs ? <></> :
                      <TableHead>
                        <TableRow>
                          <TableCell>Name</TableCell>
                          <TableCell>Export</TableCell>
                          <TableCell>Update</TableCell>
                          <TableCell>Delete</TableCell>
                        </TableRow>
                      </TableHead>
                    }
                    <TableBody>
                      <Draggable style={{ width: '350px' }}>
                        <Dialog
                          open={confirmOpen}
                          onClose={handlConfirmClose}
                          disableEscapeKeyDown
                          disableEnforceFocus
                          hideBackdrop
                          BackdropProps={{ open: false }}
                          style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}
                        >
                          <DialogTitle id="alert-dialog-title"> {option} Configuration</DialogTitle>
                          <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                              Are you sure you want to {option} configuration {comfirmItem?.description} ?
                            </DialogContentText>
                          </DialogContent>
                          <DialogActions>
                            <Button onClick={(e) => handleConfirm(e)} color="primary">
                              Yes
                            </Button>
                            <Button onClick={handlConfirmClose} color="primary" autoFocus>
                              No
                            </Button>
                          </DialogActions>
                        </Dialog>
                      </Draggable>
                      {savedConfigs?.map((item) => (
                        <TableRow key={item.id}>
                          <TableCell
                            onClick={() => handleOpenConfirm(item, 'Load')}
                          >
                            <Tooltip title={new Date(item.timestamp).toLocaleString()}>
                              <Typography
                                style={{
                                  cursor: 'pointer',
                                  color: '#000000',
                                  transition: 'color 0.2s ease',
                                  maxWidth: "150px",
                                }}
                                sx={{
                                  whiteSpace: "normal",
                                  wordBreak: "break-word",
                                  overflowWrap: "anywhere",
                                  maxWidth: "150px",
                                }}
                                onMouseEnter={(e) => (e.target.style.color = '#007BFF')}
                                onMouseLeave={(e) => (e.target.style.color = '#000000')}
                              >
                                {item.description}
                              </Typography>
                            </Tooltip>
                          </TableCell>
                          <TableCell>
                            <Tooltip title="Export">
                              <IconButton edge="end" aria-label="Export" onClick={() => handleOpenConfirm(item, 'Export')}>
                                <GetAppIcon />
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                          <TableCell>
                            <IconButton onClick={() => handleOpenConfirm(item, 'Update')} color="primary">
                              <UpdateIcon />
                            </IconButton>
                          </TableCell>
                          <TableCell>
                            <Tooltip title="Delete">
                              <IconButton edge="end" aria-label="delete" onClick={() => handleOpenConfirm(item, 'Delete')}>
                                <DeleteIcon />
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </AccordionDetails>
            </Accordion>


            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel7a-content" id="panel7a-header">
                <Typography>Drawing Files</Typography>
              </AccordionSummary>

              <TextField
                fullWidth
                variant="standard"
                placeholder={"Search Drawings..."}
                size="small"
                value={drawingFileSearchTerm}
                onChange={handleDrawingFileSearchChange}
                sx={{
                  "& fieldset": { border: "none" },
                  "& .MuiInput-underline:before": { borderBottom: "1px solid black" },
                  "& .MuiInput-underline:hover:before": { borderBottom: "1px solid black" },
                  "& .MuiInput-underline:after": { borderBottom: "2px solid black" },
                }}
                style={{
                  margin: "12px auto",
                  width: "80%",
                  display: "flex",
                  justifyContent: "center",
                }}
              />

              <Typography onClick={handleSort} variant="body2" align="center" style={{ margin: "10px 0", fontWeight: "bold", userSelect: "none", cursor: "pointer" }}>
                Sorting by: {getSortLabel()}
              </Typography>

              <AccordionDetails>
                <TableContainer style={{ overflowX: "hidden" }}>
                  <Table style={{ width: "100%" }}>
                    <TableHead>
                      <TableRow>
                        <TableCell
                          onClick={handleSort}
                          style={{ cursor: "pointer" }}
                        >
                          Name
                        </TableCell>
                        <TableCell>Update</TableCell>
                        <TableCell>Delete</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {sortedDrawingFiles?.map((drawing, index) => (
                        <TableRow key={index}>
                          <TableCell style={{ cursor: "pointer", color: "#000000", transition: "color 0.2s ease" }}>
                            <div>
                              <Tooltip title={drawing.name} placement="top">
                                <Typography
                                  variant="body1"
                                  style={{
                                    fontWeight: 'bold',
                                    fontSize: '0.9rem',
                                  }}
                                  onClick={() => handleSelectDrawing(drawing.id)}

                                  onMouseEnter={(e) => (e.target.style.color = '#007BFF')}
                                  onMouseLeave={(e) => (e.target.style.color = '#000000')}
                                >
                                  {drawing.name && drawing.name.length > 18 ? `${drawing.name.slice(0, 15)}...` : drawing.name}
                                </Typography>
                              </Tooltip>
                              <Typography
                                variant="caption"
                                color="textSecondary"
                                style={{
                                  fontSize: '0.7rem',
                                  whiteSpace: 'nowrap',
                                  cursor: 'default',
                                }}
                              >
                                Uploaded: {new Date(drawing.createDate).toLocaleDateString('en-GB')}
                              </Typography>
                            </div>
                          </TableCell>
                          <TableCell>
                            <IconButton onClick={() => handleUpdateClick(drawing.id)} color="primary">
                              <UpdateIcon />
                            </IconButton>
                          </TableCell>
                          <TableCell>
                            <IconButton onClick={() => deleteDrawing(drawing.id)} color="error">
                              <DeleteIcon />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel4a-content"
                id="panel4a-header"
              >
                <Typography>Report</Typography>
              </AccordionSummary>

              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 16px' }}>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <IconButton
                    onClick={(event) => handleAddReportCaptureArea(event)}
                  >
                    <Tooltip title="Add Capture Area">
                      <RectangleIcon />
                    </Tooltip>
                  </IconButton>

                  <IconButton
                    onClick={(e) => handleReportCaptureClickUtil(true, {
                        stageRef,
                        reportCaptureAreas,
                        setReportCaptureAreas,
                        masks,
                        setMasks,
                        realWorldWidth,
                        imagePixelWidth,
                        realWorldHeight,
                        imagePixelHeight,
                        setSnack,
                    })}
                  >
                    <Tooltip title="Generate report with masks">
                      <PublishIcon />
                    </Tooltip>
                  </IconButton>
                  <IconButton
                    onClick={(e) => handleReportCaptureClickUtil(false, {
                        stageRef,
                        reportCaptureAreas,
                        setReportCaptureAreas,
                        masks,
                        setMasks,
                        realWorldWidth,
                        imagePixelWidth,
                        realWorldHeight,
                        imagePixelHeight,
                        setSnack,
                    })}
                  >
                    <Tooltip title="Generate report without masks">
                      <PublishIcon />
                    </Tooltip>
                  </IconButton>

                  {/* Upload PDF Button */}
                  <input
                    accept="application/pdf"
                    style={{ display: 'none' }}
                    id="upload-pdf-input"
                    type="file"
                    onChange={handlePdfUpload}
                  />
                  <label htmlFor="upload-pdf-input">
                    <Tooltip title="Upload PDF">
                      <IconButton component="span">
                        <UploadFileIcon />
                      </IconButton>
                    </Tooltip>
                  </label>
                </div>
              </div>

              <AccordionDetails>
                <ReportCaptureEditor
                  deleteReportCaptureArea={deleteReportCaptureArea}
                  selectReportCaptureArea={selectReportCaptureArea}
                  setReportCaptureAreas={setReportCaptureAreas}
                  lockReportCaptureArea={lockReportCaptureArea}
                  reportCaptureAreas={reportCaptureAreas}
                />
              </AccordionDetails>
            </Accordion>


            <div style={{ marginTop: 'auto', padding: '16px', textAlign: 'right' }}>
              <IconButton onClick={toggleRightDrawer}>
                <Typography>Close</Typography>
              </IconButton>
            </div>
          </Box>
        </Drawer>
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
          <IconButton onClick={toggleLeftDrawer}>
            {/* <ArrowForwardIosIcon style={{ display: 'flex', textAlign: 'right' }} /> */}
            <Typography>Tools</Typography>
          </IconButton>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', }}>
            X: {mouseCoords.x.toFixed(2)} Y: {mouseCoords.y.toFixed(2)} {measureMode && measureStartPoint ? `Distance: ${measureDistance.toFixed(2)} m` : ''}&nbsp;
            {stage.scale && (
              <span>
                Zoom:&nbsp;
                {isEditingScale ? (
                  <input
                    ref={scaleInputRef}
                    id="scaleInput"
                    type="text"
                    value={scaleInput}
                    onChange={handleScaleChange}
                    onBlur={handleScaleBlur}
                    onKeyPress={handleKeyPress}
                    style={{ width: '80px', textAlign: 'center' }}
                  />
                ) : (
                  <span onClick={handleTextClick} style={{ cursor: 'pointer' }}>
                    {stage.scale.toFixed(2)}
                  </span>
                )}
              </span>
            )}
          </div>
          <IconButton onClick={toggleRightDrawer}>
            {/* <ArrowBackIosIcon style={{ display: 'flex', textAlign: 'left', alignItems: 'left', }} /> */}
            <Typography>Details</Typography>
          </IconButton>
        </div>
      </Grid >
      <Notification onClose={handleSnackClose} open={snack.open} severity={snack.severity} message={snack.message} action={snack.action} ></Notification>
      {/* <Loading open={isLoading} type={"backdrop"} text={"Loading Image"} /> */}
    </Page >
  );
}